import React from "react";
import "./EmptyCart.styles.scss";
import Button from "../Button/Button";
import { Link } from "react-router-dom";

const EmptyCart = () => {
  return (
    <div className="emptyCart">
      <svg
        width="150"
        height="150"
        viewBox="0 0 376 376"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M76.3875 204.348C11.0485 242.073 11.05 303.235 76.3913 340.958C141.733 378.682 247.67 378.682 313.009 340.958C378.348 303.234 378.346 242.072 313.005 204.348C247.664 166.625 141.727 166.625 76.3875 204.348Z"
          fill="#F5F5F5"
        />
        <path
          d="M142.809 219.813L52.8859 271.879C49.8441 273.64 49.8449 276.494 52.889 278.253L155.969 337.822C159.013 339.581 163.946 339.578 166.988 337.816L256.908 285.735C259.95 283.973 259.948 281.12 256.904 279.361L153.827 219.808C150.784 218.05 145.85 218.052 142.809 219.813Z"
          fill="#E0E0E0"
        />
        <path
          d="M336.631 310.289L274.103 274.097L217.65 306.754L280.179 342.941L336.631 310.289Z"
          fill="#E0E0E0"
        />
        <path
          d="M191.327 180.757L174.534 171.019C171.853 169.451 168.448 169.921 166.292 172.157L145.259 193.972C141.127 198.257 142.109 205.282 147.257 208.271L241.307 262.87C244.307 264.374 246.054 266.654 246.207 269.282C246.353 271.886 244.832 274.441 242.042 276.277L191.17 305.602C188.655 307.251 185.283 308.189 181.871 308.375C178.475 308.577 175.063 308.019 172.386 306.685L81.0889 254.103C76.2701 251.33 75.0488 244.926 78.5012 240.584L99.1271 214.621C101.207 212.002 104.895 211.309 107.784 212.993L123.949 222.316"
          stroke="#263238"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M161.155 302.081C155.684 309.183 146.775 311.198 144.771 310.261C143.159 309.516 142.202 307.591 143.431 306.443C143.995 305.919 144.972 305.375 145.889 304.61C148.568 302.384 149.455 298.506 149.707 295.483L161.155 302.081Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.2"
          d="M161.155 302.081C155.684 309.183 146.775 311.198 144.771 310.261C143.159 309.516 142.202 307.591 143.431 306.443C143.995 305.919 144.972 305.375 145.889 304.61C148.568 302.384 149.455 298.506 149.707 295.483L161.155 302.081Z"
          fill="black"
        />
        <path
          d="M155.38 312.962C155.417 307.243 151.445 300.262 146.51 297.371C143.92 295.853 141.589 295.779 139.944 296.864L133.873 300.279L146.597 322.218L152.615 318.807L152.606 318.792C154.295 317.891 155.361 315.881 155.38 312.962Z"
          fill="#37474F"
        />
        <path
          d="M140.208 300.949C145.144 303.84 149.114 310.82 149.077 316.54C149.041 322.259 145.011 324.552 140.076 321.661C135.141 318.769 131.17 311.789 131.206 306.069C131.243 300.351 135.274 298.058 140.208 300.949Z"
          fill="#455A64"
        />
        <path
          d="M140.175 306.083C142.664 307.541 144.667 311.062 144.648 313.946C144.63 316.83 142.597 317.986 140.108 316.528C137.619 315.07 135.617 311.55 135.635 308.665C135.654 305.781 137.687 304.625 140.175 306.083Z"
          fill="#263238"
        />
        <path
          d="M145.481 293.055C145.481 293.055 146.069 303.613 141.233 307.645C140.321 308.406 139.338 308.952 138.771 309.48C137.543 310.625 138.507 312.548 140.12 313.298C142.464 314.389 154.478 311.299 159.16 300.929L145.481 293.055Z"
          fill="#F28B0B"
        />
        <path
          d="M140.356 310.167C140.864 310.423 141.301 311.091 141.333 311.66C141.365 312.227 140.98 312.48 140.472 312.224C139.964 311.967 139.526 311.299 139.494 310.732C139.463 310.164 139.848 309.911 140.356 310.167Z"
          fill="#FAFAFA"
        />
        <path
          d="M104.621 269.521C99.1506 276.622 90.2289 278.658 88.2248 277.721C86.6133 276.976 85.656 275.052 86.8847 273.903C87.4487 273.379 88.4263 272.835 89.343 272.07C92.0224 269.844 92.9113 265.945 93.1632 262.923L104.621 269.521Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.2"
          d="M104.621 269.521C99.1506 276.622 90.2289 278.658 88.2248 277.721C86.6133 276.976 85.656 275.052 86.8847 273.903C87.4487 273.379 88.4263 272.835 89.343 272.07C92.0224 269.844 92.9113 265.945 93.1632 262.923L104.621 269.521Z"
          fill="black"
        />
        <path
          d="M98.8346 280.422C98.8714 274.703 94.9001 267.723 89.9647 264.832C87.3748 263.314 85.0436 263.24 83.399 264.325L77.3281 267.74L90.052 289.679L96.0695 286.268L96.0612 286.253C97.7494 285.352 98.8158 283.341 98.8346 280.422Z"
          fill="#37474F"
        />
        <path
          d="M83.6631 268.409C88.5977 271.301 92.569 278.281 92.5322 284C92.4961 289.719 88.4661 292.013 83.5307 289.121C78.5961 286.23 74.6248 279.25 74.6616 273.529C74.6977 267.811 78.7284 265.518 83.6631 268.409Z"
          fill="#455A64"
        />
        <path
          d="M83.63 273.542C86.1192 275 88.1217 278.52 88.1029 281.405C88.0849 284.29 86.0522 285.446 83.5631 283.988C81.074 282.529 79.0714 279.009 79.0902 276.125C79.109 273.24 81.1409 272.084 83.63 273.542Z"
          fill="#263238"
        />
        <path
          d="M88.9016 260.469C88.9016 260.469 89.5243 271.073 84.6874 275.105C83.776 275.864 82.7931 276.411 82.2254 276.941C80.9981 278.085 81.9622 280.008 83.5745 280.758C85.9184 281.848 97.9331 278.735 102.615 268.365L88.9016 260.469Z"
          fill="#F28B0B"
        />
        <path
          d="M83.8107 277.627C84.319 277.884 84.756 278.551 84.7883 279.119C84.8206 279.687 84.4348 279.94 83.9272 279.683C83.4196 279.427 82.982 278.759 82.9496 278.191C82.9173 277.623 83.3031 277.371 83.8107 277.627Z"
          fill="#FAFAFA"
        />
        <path
          d="M234.104 260.561C228.624 267.642 219.711 269.685 217.707 268.748C216.095 268.003 215.138 266.079 216.367 264.93C216.931 264.407 217.909 263.863 218.824 263.097C221.504 260.871 222.399 256.927 222.651 253.905L234.104 260.561Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.2"
          d="M234.104 260.561C228.624 267.642 219.711 269.685 217.707 268.748C216.095 268.003 215.138 266.079 216.367 264.93C216.931 264.407 217.909 263.863 218.824 263.097C221.504 260.871 222.399 256.927 222.651 253.905L234.104 260.561Z"
          fill="black"
        />
        <path
          d="M228.312 271.452C228.348 265.734 224.377 258.753 219.442 255.861C216.852 254.344 214.521 254.269 212.876 255.354L206.805 258.769L219.529 280.709L225.546 277.298L225.537 277.283C227.226 276.382 228.294 274.371 228.312 271.452Z"
          fill="#37474F"
        />
        <path
          d="M213.14 259.44C218.075 262.332 222.046 269.312 222.009 275.031C221.973 280.751 217.943 283.043 213.008 280.152C208.072 277.26 204.102 270.28 204.139 264.56C204.176 258.841 208.205 256.549 213.14 259.44Z"
          fill="#455A64"
        />
        <path
          d="M213.108 264.573C215.597 266.031 217.6 269.551 217.581 272.436C217.563 275.321 215.53 276.477 213.041 275.018C210.552 273.56 208.549 270.04 208.568 267.156C208.586 264.271 210.619 263.115 213.108 264.573Z"
          fill="#263238"
        />
        <path
          d="M218.424 251.45C218.424 251.45 219.001 262.104 214.164 266.136C213.253 266.896 212.27 267.441 211.702 267.971C210.475 269.116 211.439 271.039 213.051 271.789C215.395 272.879 227.429 269.768 232.111 259.399L218.424 251.45Z"
          fill="#F28B0B"
        />
        <path
          d="M213.288 268.657C213.796 268.914 214.233 269.581 214.266 270.149C214.298 270.717 213.912 270.97 213.405 270.713C212.896 270.457 212.459 269.789 212.427 269.221C212.395 268.654 212.78 268.402 213.288 268.657Z"
          fill="#FAFAFA"
        />
        <path
          d="M178.01 227.995C172.54 235.097 163.623 237.106 161.619 236.169C160.007 235.424 159.05 233.5 160.279 232.351C160.843 231.827 161.82 231.284 162.737 230.518C165.416 228.292 166.303 224.413 166.555 221.392L178.01 227.995Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.2"
          d="M178.01 227.995C172.54 235.097 163.623 237.106 161.619 236.169C160.007 235.424 159.05 233.5 160.279 232.351C160.843 231.827 161.82 231.284 162.737 230.518C165.416 228.292 166.303 224.413 166.555 221.392L178.01 227.995Z"
          fill="black"
        />
        <path
          d="M172.228 238.871C172.264 233.152 168.293 226.171 163.358 223.28C160.767 221.763 158.437 221.688 156.792 222.773L150.721 226.188L163.445 248.128L169.463 244.717L169.454 244.701C171.142 243.8 172.21 241.789 172.228 238.871Z"
          fill="#37474F"
        />
        <path
          d="M157.056 226.857C161.991 229.749 165.962 236.729 165.925 242.449C165.889 248.168 161.859 250.46 156.924 247.57C151.989 244.678 148.018 237.698 148.054 231.978C148.092 226.259 152.122 223.966 157.056 226.857Z"
          fill="#455A64"
        />
        <path
          d="M157.024 231.99C159.513 233.449 161.516 236.969 161.497 239.853C161.479 242.738 159.446 243.894 156.957 242.436C154.468 240.978 152.465 237.458 152.484 234.573C152.502 231.688 154.535 230.532 157.024 231.99Z"
          fill="#263238"
        />
        <path
          d="M162.296 218.869C162.296 218.869 162.92 229.514 158.083 233.546C157.172 234.306 156.189 234.852 155.621 235.381C154.394 236.526 155.358 238.449 156.97 239.199C159.314 240.29 171.329 237.2 176.011 226.831L162.296 218.869Z"
          fill="#F28B0B"
        />
        <path
          d="M157.204 236.075C157.712 236.331 158.15 237 158.182 237.567C158.214 238.135 157.828 238.388 157.321 238.131C156.813 237.875 156.375 237.207 156.343 236.639C156.311 236.072 156.696 235.819 157.204 236.075Z"
          fill="#FAFAFA"
        />
        <path
          d="M150.078 152.874L147.18 154.547L141.367 49.7049C139.956 44.0085 134.473 36.7021 129.376 33.7738L126.62 32.1766C125.223 31.3652 122.761 31.3652 121.363 32.1766L112.971 36.9916C112.172 37.4571 111.161 37.1781 110.695 36.3795C110.243 35.5944 110.509 34.5694 111.307 34.1175L119.7 29.2889C122.109 27.9052 125.875 27.9052 128.271 29.2889L131.039 30.8861C136.895 34.2671 142.977 42.3451 144.601 48.9063L150.078 152.874Z"
          fill="#455A64"
        />
        <path
          d="M50.5307 78.0395L45.1216 68.6704L112.514 29.7423L112.513 29.7408C113.214 29.1844 114.275 29.1979 115.448 29.8762C117.561 31.0967 119.273 34.0618 119.273 36.5013C119.274 37.8572 118.756 38.7821 117.923 39.1107H117.923L50.5307 78.0395Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.25"
          d="M50.5307 78.0395L45.1216 68.6704L112.514 29.7423L112.513 29.7408C113.214 29.1844 114.275 29.1979 115.448 29.8762C117.561 31.0967 119.273 34.0618 119.273 36.5013C119.274 37.8572 118.756 38.7821 117.923 39.1107H117.923L50.5307 78.0395Z"
          fill="black"
        />
        <path
          d="M45.1209 68.6704C46.5437 67.8492 48.9072 69.281 50.4007 71.8679C51.8942 74.4547 51.9521 77.2183 50.5301 78.0395C49.1073 78.8607 46.7437 77.4289 45.2495 74.842C43.7568 72.2552 43.6989 69.4915 45.1209 68.6704Z"
          fill="#F28B0B"
        />
        <path
          d="M77.7606 194.626L75.0595 196.186L55.0916 100.115C53.6809 94.4189 48.1845 87.126 43.1002 84.1977L40.3314 82.5869C38.8943 81.762 38.0693 80.5106 38.0693 79.1533C38.0693 77.7959 38.8943 76.5446 40.3314 75.7196L46.327 72.2995C46.7662 72.0469 47.4979 72.4853 47.9506 73.2847C48.4161 74.0833 48.4296 74.9345 47.9905 75.188h37.9777L41.9955 78.6081C41.5165 78.8743 41.4097 79.1134 41.3969 79.1533C41.4105 79.2067 41.5173 79.4323 41.9955 79.7128L44.7636 81.31C50.6195 84.6902 56.6889 92.769 58.3117 99.3166L77.7606 194.626Z"
          fill="#455A64"
        />
        <path
          d="M75.0596 196.186L150.078 152.874L259.72 216.177L184.702 259.488L75.0596 196.186Z"
          fill="#E0E0E0"
        />
        <g opacity="0.2">
          <path
            d="M75.0596 196.186L150.078 152.874L259.72 216.177L184.702 259.488L75.0596 196.186Z"
            fill="black"
          />
        </g>
        <path
          d="M150.078 153.249C149.88 153.249 149.714 153.094 149.703 152.894L143.907 48.8913C143.895 48.6837 144.054 48.5062 144.262 48.495C144.466 48.4777 144.647 48.6424 144.658 48.8492L150.454 152.852C150.466 153.06 150.307 153.237 150.099 153.249C150.093 153.249 150.085 153.249 150.078 153.249Z"
          fill="#E0E0E0"
        />
        <path
          d="M163.784 161.163C163.579 161.163 163.411 160.997 163.408 160.791L162.15 61.115C162.147 60.9075 162.314 60.7368 162.522 60.7345C162.523 60.7345 162.525 60.7345 162.526 60.7345C162.731 60.7345 162.899 60.9 162.902 61.106L164.16 160.782C164.163 160.99 163.996 161.16 163.789 161.163C163.787 161.163 163.786 161.163 163.784 161.163Z"
          fill="#E0E0E0"
        />
        <path
          d="M177.489 169.075C177.486 169.075 177.482 169.075 177.479 169.075C177.271 169.07 177.107 168.897 177.113 168.689L179.601 73.0876C179.607 72.8808 179.782 72.7154 179.987 72.7214C180.194 72.7267 180.358 72.8996 180.353 73.1072L177.865 168.709C177.86 168.913 177.692 169.075 177.489 169.075Z"
          fill="#E0E0E0"
        />
        <path
          d="M191.194 176.988C191.188 176.988 191.182 176.988 191.176 176.988C190.969 176.977 190.809 176.801 190.819 176.594L195.357 83.9427C195.367 83.7359 195.551 83.569 195.75 83.5855C195.957 83.5961 196.117 83.772 196.107 83.9796L191.569 176.63C191.559 176.832 191.394 176.988 191.194 176.988Z"
          fill="#E0E0E0"
        />
        <path
          d="M204.901 184.901C204.891 184.901 204.882 184.901 204.872 184.9C204.665 184.884 204.51 184.704 204.525 184.497L211.22 94.8505C211.236 94.643 211.412 94.4896 211.624 94.5031C211.83 94.5189 211.986 94.6986 211.971 94.9062L205.275 184.553C205.259 184.751 205.095 184.901 204.901 184.901Z"
          fill="#E0E0E0"
        />
        <path
          d="M218.605 192.814C218.592 192.814 218.578 192.814 218.564 192.812C218.358 192.79 218.208 192.605 218.231 192.398L227.386 105.856C227.408 105.649 227.595 105.495 227.8 105.522C228.006 105.544 228.156 105.729 228.134 105.936L218.978 192.478C218.958 192.671 218.795 192.814 218.605 192.814Z"
          fill="#E0E0E0"
        />
        <path
          d="M232.311 200.727C232.292 200.727 232.273 200.725 232.255 200.722C232.049 200.692 231.908 200.501 231.939 200.295L244.371 117.463C244.401 117.257 244.592 117.117 244.798 117.147C245.003 117.178 245.145 117.37 245.114 117.575L232.682 200.408C232.654 200.593 232.494 200.727 232.311 200.727Z"
          fill="#E0E0E0"
        />
        <path
          d="M246.015 208.639C245.992 208.639 245.97 208.637 245.946 208.633C245.741 208.595 245.607 208.399 245.645 208.194L260.493 128.533C260.531 128.328 260.731 128.197 260.931 128.232C261.135 128.27 261.27 128.466 261.231 128.67L246.384 208.332C246.351 208.513 246.193 208.639 246.015 208.639Z"
          fill="#E0E0E0"
        />
        <path
          d="M259.721 216.552C259.694 216.552 259.666 216.549 259.638 216.542C259.435 216.496 259.308 216.295 259.354 216.092L276.665 139.464C276.71 139.263 276.909 139.133 277.115 139.181C277.318 139.227 277.445 139.428 277.399 139.631L260.088 216.259C260.048 216.434 259.893 216.552 259.721 216.552Z"
          fill="#E0E0E0"
        />
        <path
          d="M75.0582 196.562C74.8837 196.562 74.7273 196.439 74.6904 196.261L55.1114 100.105C55.07 99.9017 55.2016 99.7024 55.4054 99.6618C55.6054 99.6189 55.807 99.7513 55.8491 99.9551L75.4281 196.111C75.4695 196.315 75.3379 196.513 75.1341 196.555C75.1093 196.559 75.0837 196.562 75.0582 196.562Z"
          fill="#E0E0E0"
        />
        <path
          d="M93.8139 185.734C93.6311 185.734 93.4709 185.6 93.4431 185.414L78.5829 86.5326C78.552 86.3273 78.6926 86.1356 78.8987 86.1047C79.0995 86.0777 79.2957 86.2153 79.3258 86.4206L94.1861 185.302C94.2169 185.507 94.0763 185.698 93.8703 185.729C93.8515 185.733 93.8327 185.734 93.8139 185.734Z"
          fill="#E0E0E0"
        />
        <path
          d="M112.568 174.905C112.379 174.905 112.217 174.763 112.195 174.572L100.836 73.6621C100.813 73.4561 100.962 73.2696 101.168 73.2463C101.356 73.2267 101.559 73.3711 101.584 73.5779L112.942 174.487C112.965 174.693 112.817 174.88 112.611 174.903C112.597 174.905 112.582 174.905 112.568 174.905Z"
          fill="#E0E0E0"
        />
        <path
          d="M131.324 164.077C131.13 164.077 130.966 163.929 130.95 163.733L122.282 61.4203C122.264 61.2135 122.418 61.0316 122.625 61.0143C122.814 60.9879 123.013 61.1496 123.031 61.3572L131.698 163.67C131.715 163.877 131.562 164.059 131.355 164.076C131.345 164.077 131.334 164.077 131.324 164.077Z"
          fill="#E0E0E0"
        />
        <path
          d="M150.079 153.249C149.88 153.249 149.715 153.094 149.703 152.894L143.908 48.8913C143.896 48.6837 144.054 48.5062 144.263 48.495C144.466 48.4777 144.648 48.6424 144.658 48.8492L150.454 152.852C150.466 153.06 150.307 153.237 150.099 153.249C150.093 153.249 150.085 153.249 150.079 153.249Z"
          fill="#E0E0E0"
        />
        <path
          d="M259.721 216.552C259.657 216.552 259.592 216.535 259.533 216.502L150.078 153.308L75.2469 196.511C75.0664 196.615 74.8355 196.554 74.7333 196.374C74.6287 196.194 74.6904 195.964 74.8709 195.86L149.89 152.548C150.006 152.481 150.151 152.481 150.266 152.548L259.909 215.85C260.088 215.954 260.15 216.183 260.046 216.364C259.977 216.484 259.85 216.552 259.721 216.552Z"
          fill="#E0E0E0"
        />
        <path
          d="M264.048 197.395C263.98 197.395 263.911 197.377 263.849 197.338L148.389 125.137L70.2843 171.503C70.1038 171.61 69.8737 171.549 69.7692 171.372C69.6624 171.193 69.7218 170.963 69.9008 170.856L148.202 124.373C148.322 124.301 148.474 124.303 148.593 124.377L264.248 196.7C264.424 196.81 264.478 197.042 264.367 197.217C264.296 197.332 264.173 197.395 264.048 197.395Z"
          fill="#E0E0E0"
        />
        <path
          d="M268.376 178.238C268.307 178.238 268.238 178.219 268.175 178.18L147.17 101.896L65.4542 147.748C65.2715 147.849 65.0429 147.785 64.9414 147.604C64.8398 147.423 64.9045 147.194 65.085 147.092L146.996 101.131C147.116 101.064 147.264 101.067 147.381 101.141L268.576 177.544C268.751 177.655 268.805 177.887 268.693 178.062C268.623 178.176 268.5 178.238 268.376 178.238Z"
          fill="#E0E0E0"
        />
        <path
          d="M272.704 159.081C272.633 159.081 272.561 159.062 272.498 159.019L145.834 76.0024L60.5309 123.444C60.3504 123.544 60.1203 123.48 60.0195 123.298C59.918 123.116 59.9834 122.887 60.1647 122.787L145.666 75.2353C145.789 75.1676 145.939 75.1721 146.056 75.2496L272.909 158.391C273.082 158.505 273.131 158.738 273.018 158.912C272.946 159.021 272.826 159.081 272.704 159.081Z"
          fill="#E0E0E0"
        />
        <path
          d="M277.031 139.924C276.957 139.924 276.884 139.903 276.819 139.858L144.266 49.3138L55.6678 100.356C55.4865 100.46 55.2579 100.397 55.1534 100.217C55.0496 100.038 55.1113 99.8076 55.2918 99.7038L144.095 48.5445C144.221 48.4715 144.376 48.479 144.495 48.5595L277.243 139.236C277.414 139.354 277.458 139.588 277.342 139.759C277.269 139.866 277.151 139.924 277.031 139.924Z"
          fill="#E0E0E0"
        />
        <g opacity="0.2">
          <path
            d="M150.078 153.249C149.88 153.249 149.714 153.094 149.703 152.894L143.907 48.8913C143.895 48.6837 144.054 48.5062 144.262 48.495C144.466 48.4777 144.647 48.6424 144.658 48.8492L150.454 152.852C150.466 153.06 150.307 153.237 150.099 153.249C150.093 153.249 150.085 153.249 150.078 153.249Z"
            fill="black"
          />
          <path
            d="M163.784 161.163C163.579 161.163 163.411 160.997 163.408 160.791L162.15 61.115C162.147 60.9075 162.314 60.7368 162.522 60.7345C162.523 60.7345 162.525 60.7345 162.526 60.7345C162.731 60.7345 162.899 60.9 162.902 61.106L164.16 160.782C164.163 160.99 163.996 161.16 163.789 161.163C163.787 161.163 163.786 161.163 163.784 161.163Z"
            fill="black"
          />
          <path
            d="M177.489 169.075C177.486 169.075 177.482 169.075 177.479 169.075C177.271 169.07 177.107 168.897 177.113 168.689L179.601 73.0876C179.607 72.8808 179.782 72.7154 179.987 72.7214C180.194 72.7267 180.358 72.8996 180.353 73.1072L177.865 168.709C177.86 168.913 177.692 169.075 177.489 169.075Z"
            fill="black"
          />
          <path
            d="M191.194 176.988C191.188 176.988 191.182 176.988 191.176 176.988C190.969 176.977 190.809 176.801 190.819 176.594L195.357 83.9427C195.367 83.7359 195.551 83.569 195.75 83.5855C195.957 83.5961 196.117 83.772 196.107 83.9796L191.569 176.63C191.559 176.832 191.394 176.988 191.194 176.988Z"
            fill="black"
          />
          <path
            d="M204.901 184.901C204.891 184.901 204.882 184.901 204.872 184.9C204.665 184.884 204.51 184.704 204.525 184.497L211.22 94.8505C211.236 94.643 211.412 94.4896 211.624 94.5031C211.83 94.5189 211.986 94.6986 211.971 94.9062L205.275 184.553C205.259 184.751 205.095 184.901 204.901 184.901Z"
            fill="black"
          />
          <path
            d="M218.605 192.814C218.592 192.814 218.578 192.814 218.564 192.812C218.358 192.79 218.208 192.605 218.231 192.398L227.386 105.856C227.408 105.649 227.595 105.495 227.8 105.522C228.006 105.544 228.156 105.729 228.134 105.936L218.978 192.478C218.958 192.671 218.795 192.814 218.605 192.814Z"
            fill="black"
          />
          <path
            d="M232.311 200.727C232.292 200.727 232.273 200.725 232.255 200.722C232.049 200.692 231.908 200.501 231.939 200.295L244.371 117.463C244.401 117.257 244.592 117.117 244.798 117.147C245.003 117.178 245.145 117.37 245.114 117.575L232.682 200.408C232.654 200.593 232.494 200.727 232.311 200.727Z"
            fill="black"
          />
          <path
            d="M246.015 208.639C245.992 208.639 245.97 208.637 245.946 208.633C245.741 208.595 245.607 208.399 245.645 208.194L260.493 128.533C260.531 128.328 260.731 128.197 260.931 128.232C261.135 128.27 261.27 128.466 261.231 128.67L246.384 208.332C246.351 208.513 246.193 208.639 246.015 208.639Z"
            fill="black"
          />
          <path
            d="M259.721 216.552C259.694 216.552 259.666 216.549 259.638 216.542C259.435 216.496 259.308 216.295 259.354 216.092L276.665 139.464C276.71 139.263 276.909 139.133 277.115 139.181C277.318 139.227 277.445 139.428 277.399 139.631L260.088 216.259C260.048 216.434 259.893 216.552 259.721 216.552Z"
            fill="black"
          />
          <path
            d="M75.0582 196.562C74.8837 196.562 74.7273 196.439 74.6904 196.261L55.1114 100.105C55.07 99.9017 55.2016 99.7024 55.4054 99.6618C55.6054 99.6189 55.807 99.7513 55.8491 99.9551L75.4281 196.111C75.4695 196.315 75.3379 196.513 75.1341 196.555C75.1093 196.559 75.0837 196.562 75.0582 196.562Z"
            fill="black"
          />
          <path
            d="M93.8139 185.734C93.6311 185.734 93.4709 185.6 93.4431 185.414L78.5829 86.5326C78.552 86.3273 78.6926 86.1356 78.8987 86.1047C79.0995 86.0777 79.2957 86.2153 79.3258 86.4206L94.1861 185.302C94.2169 185.507 94.0763 185.698 93.8703 185.729C93.8515 185.733 93.8327 185.734 93.8139 185.734Z"
            fill="black"
          />
          <path
            d="M112.568 174.905C112.379 174.905 112.217 174.763 112.195 174.572L100.836 73.6621C100.813 73.4561 100.962 73.2696 101.168 73.2463C101.356 73.2267 101.559 73.3711 101.584 73.5779L112.942 174.487C112.965 174.693 112.817 174.88 112.611 174.903C112.597 174.905 112.582 174.905 112.568 174.905Z"
            fill="black"
          />
          <path
            d="M131.324 164.077C131.13 164.077 130.966 163.929 130.95 163.733L122.282 61.4203C122.264 61.2135 122.418 61.0316 122.625 61.0143C122.814 60.9879 123.013 61.1496 123.031 61.3572L131.698 163.67C131.715 163.877 131.562 164.059 131.355 164.076C131.345 164.077 131.334 164.077 131.324 164.077Z"
            fill="black"
          />
          <path
            d="M150.079 153.249C149.88 153.249 149.715 153.094 149.703 152.894L143.908 48.8913C143.896 48.6837 144.054 48.5062 144.263 48.495C144.466 48.4777 144.648 48.6424 144.658 48.8492L150.454 152.852C150.466 153.06 150.307 153.237 150.099 153.249C150.093 153.249 150.085 153.249 150.079 153.249Z"
            fill="black"
          />
          <path
            d="M259.721 216.552C259.657 216.552 259.592 216.535 259.533 216.502L150.078 153.308L75.2469 196.511C75.0664 196.615 74.8355 196.554 74.7333 196.374C74.6287 196.194 74.6904 195.964 74.8709 195.86L150.078 152.439L150.266 152.548L259.909 215.85C260.088 215.954 260.15 216.183 260.046 216.364C259.977 216.484 259.85 216.552 259.721 216.552Z"
            fill="black"
          />
          <path
            d="M264.048 197.395C263.98 197.395 263.911 197.377 263.849 197.338L148.389 125.137L70.2843 171.503C70.1038 171.61 69.8737 171.549 69.7692 171.372C69.6624 171.193 69.7218 170.963 69.9008 170.856L148.399 124.256L148.593 124.378L264.248 196.701C264.424 196.81 264.478 197.043 264.367 197.218C264.296 197.332 264.173 197.395 264.048 197.395Z"
            fill="black"
          />
          <path
            d="M268.376 178.238C268.307 178.238 268.238 178.219 268.175 178.18L147.17 101.896L65.4542 147.748C65.2715 147.849 65.0429 147.785 64.9414 147.604C64.8398 147.423 64.9045 147.194 65.085 147.092L147.191 101.021L147.381 101.141L268.576 177.544C268.751 177.655 268.805 177.887 268.693 178.062C268.623 178.176 268.5 178.238 268.376 178.238Z"
            fill="black"
          />
          <path
            d="M272.704 159.081C272.633 159.081 272.561 159.062 272.498 159.019L145.834 76.0024L60.5309 123.444C60.3504 123.544 60.1203 123.48 60.0195 123.298C59.918 123.116 59.9834 122.887 60.1647 122.787L145.866 75.1248L146.056 75.2496L272.909 158.391C273.082 158.505 273.131 158.738 273.018 158.912C272.946 159.021 272.826 159.081 272.704 159.081Z"
            fill="black"
          />
          <path
            d="M277.031 139.924C276.957 139.924 276.884 139.903 276.819 139.858L144.266 49.3139L55.6678 100.356C55.4865 100.46 55.2579 100.397 55.1534 100.218C55.0496 100.038 55.1113 99.8077 55.2918 99.7039L144.299 48.4265L144.495 48.5596L277.243 139.237C277.414 139.354 277.458 139.588 277.342 139.759C277.269 139.866 277.151 139.924 277.031 139.924Z"
            fill="black"
          />
        </g>
        <path
          opacity="0.15"
          d="M80.1677 195.238L138.042 161.74L190.291 191.966L132.417 225.458L80.1677 195.238Z"
          fill="black"
        />
        <path
          opacity="0.15"
          d="M145.675 219.972L205.201 185.481L257.45 215.706L197.925 250.193L145.675 219.972Z"
          fill="black"
        />
        <path
          d="M127.841 77.4778L127.798 142.508L179.953 172.545L179.996 107.516L127.841 77.4778Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.1"
          d="M127.841 77.4778L127.798 142.508L179.953 172.545L179.996 107.516L127.841 77.4778Z"
          fill="black"
        />
        <path
          d="M204.689 93.2585L152.534 63.2214L127.841 77.4778L179.996 107.516L204.689 93.2585Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.3"
          d="M204.689 93.2585L152.534 63.2214L127.841 77.4778L179.996 107.516L204.689 93.2585Z"
          fill="white"
        />
        <path
          d="M191.916 93.994C191.997 94.1331 192.037 94.2835 192.038 94.4422C192.037 94.8527 191.749 95.2551 191.245 95.5453L188.084 97.3704C188.083 97.3712 188.08 97.3727 188.078 97.3742L187.844 97.5096L187.78 97.3321L184.893 95.6935L188.425 93.6541C189.324 93.1352 190.648 93.0863 191.438 93.5428C191.654 93.6653 191.816 93.8202 191.916 93.994ZM188.088 96.838L191.015 95.1475C191.373 94.9415 191.579 94.6835 191.579 94.4414C191.578 94.2015 191.376 94.0361 191.209 93.9383C190.569 93.5698 189.399 93.6202 188.655 94.0504L188.396 94.2L188.926 95.1175L187.791 96.0138L188.088 96.838ZM188.33 95.0031L187.998 94.4294L185.816 95.6897L187.538 96.6673L187.246 95.8597L188.33 95.0031Z"
          fill="#455A64"
        />
        <path
          d="M194.178 92.0922C194.241 92.202 194.204 92.3426 194.094 92.4057L191.439 93.9391C191.329 94.0022 191.188 93.9646 191.125 93.8549C191.062 93.7451 191.1 93.6044 191.209 93.5413L193.865 92.0079C193.974 91.9448 194.115 91.9824 194.178 92.0922Z"
          fill="#455A64"
        />
        <path
          d="M195.511 92.8622C195.55 92.9306 195.554 93.0186 195.511 93.0916C195.447 93.2014 195.308 93.239 195.198 93.1758L192.532 91.6357C192.422 91.5755 192.382 91.4334 192.448 91.3229C192.512 91.2131 192.652 91.1755 192.761 91.2387L195.427 92.778C195.463 92.7983 195.491 92.8276 195.511 92.8622Z"
          fill="#455A64"
        />
        <path
          d="M186.188 87.2771C186.233 87.3545 186.257 87.4388 186.258 87.5268C186.258 87.7283 186.134 87.9155 185.917 88.0411L185.372 88.3555C185.263 88.4186 185.122 88.381 185.059 88.2712C184.996 88.1614 185.033 88.0216 185.143 87.9577L185.688 87.6433C185.769 87.5959 185.799 87.5486 185.799 87.5283C185.798 87.508 185.768 87.4628 185.69 87.4185C185.485 87.3034 184.978 87.3365 184.578 87.5674L181.045 89.6068C180.936 89.67 180.795 89.6324 180.732 89.5226C180.669 89.4128 180.706 89.2721 180.815 89.209L184.347 87.1696C184.865 86.871 185.538 86.8056 185.913 87.0184C186.037 87.0876 186.13 87.1763 186.188 87.2771Z"
          fill="#455A64"
        />
        <path
          d="M184.309 91.1536L183.965 91.3529C182.345 92.2884 179.711 92.2892 178.092 91.3537C177.264 90.8746 176.807 90.2249 176.809 89.5256C176.809 88.8247 177.264 88.1757 178.092 87.6982L178.207 87.632L184.309 91.1536ZM177.441 90.1414C177.615 90.4422 177.913 90.7197 178.322 90.9559C179.696 91.7492 181.868 91.8116 183.369 91.1409L178.209 88.1622C177.6 88.5442 177.267 89.0247 177.267 89.5248C177.267 89.7361 177.327 89.9437 177.441 90.1414Z"
          fill="#455A64"
        />
        <path
          d="M177.997 82.4884C178.06 82.5981 178.022 82.7388 177.913 82.8019L171.149 86.7071C171.039 86.7702 170.899 86.7326 170.836 86.6229C170.772 86.5131 170.81 86.3724 170.92 86.3093L177.684 82.4034C177.792 82.341 177.933 82.3786 177.997 82.4884Z"
          fill="#455A64"
        />
        <path
          d="M172.911 86.1995C172.927 86.2266 172.937 86.2551 172.94 86.2882C172.956 86.4146 172.865 86.5274 172.738 86.5424L170.697 86.7785L171.152 85.4633C171.193 85.343 171.324 85.2805 171.444 85.3212C171.564 85.3648 171.628 85.4941 171.586 85.6129L171.37 86.2371L172.687 86.0859C172.78 86.0747 172.868 86.1228 172.911 86.1995Z"
          fill="#455A64"
        />
        <path
          d="M175.887 81.2551C175.95 81.3649 175.912 81.5055 175.803 81.5687L169.038 85.4746C168.928 85.5377 168.787 85.5001 168.724 85.3911C168.661 85.2813 168.698 85.1407 168.808 85.0775L175.573 81.1716C175.683 81.1069 175.824 81.1453 175.887 81.2551Z"
          fill="#455A64"
        />
        <path
          d="M170.802 84.9662C170.818 84.9933 170.827 85.0218 170.83 85.0549C170.845 85.182 170.755 85.2948 170.629 85.3091L168.586 85.5452L169.042 84.23C169.083 84.1097 169.214 84.0465 169.333 84.0879C169.453 84.1315 169.517 84.2608 169.475 84.3796L169.259 85.0046L170.576 84.8526C170.67 84.8421 170.758 84.8895 170.802 84.9662Z"
          fill="#455A64"
        />
        <path
          d="M204.69 93.2585L204.646 158.288L179.953 172.545L179.996 107.516L204.69 93.2585Z"
          fill="#F28B0B"
        />
        <path
          d="M184.487 147.537L184.487 136.122L179.953 138.739V150.154L184.487 147.537Z"
          fill="#37474F"
        />
        <path
          d="M179.954 138.739L127.798 108.702V120.117L179.953 150.154L179.954 138.739Z"
          fill="#263238"
        />
        <path
          d="M190.3 158.992L190.304 145.22C190.303 144.879 190.546 144.459 190.842 144.288L198.02 140.143C198.611 139.801 199.095 140.081 199.095 140.763L199.093 154.536C199.093 154.877 198.851 155.297 198.555 155.468L191.375 159.612C190.785 159.953 190.3 159.674 190.3 158.992Z"
          fill="#FAFAFA"
        />
        <path
          d="M191.566 158.604V158.135L197.903 154.477V154.945L191.566 158.604Z"
          fill="#455A64"
        />
        <path
          d="M191.566 156.697L191.572 155.885L197.909 152.227L197.903 153.038L191.566 156.697Z"
          fill="#455A64"
        />
        <path
          d="M191.565 154.789L191.566 154.321L197.902 150.662V151.131L191.565 154.789Z"
          fill="#455A64"
        />
        <path
          d="M191.554 153.358L191.565 152.414L197.902 148.756L197.89 149.7L191.554 153.358Z"
          fill="#455A64"
        />
        <path
          d="M191.564 150.975V150.507L197.902 146.849V147.317L191.564 150.975Z"
          fill="#455A64"
        />
        <path
          d="M191.552 149.61L191.565 148.6L197.901 144.942L197.888 145.951L191.552 149.61Z"
          fill="#455A64"
        />
        <path
          d="M191.564 147.162V146.693L197.901 143.035V143.503L191.564 147.162Z"
          fill="#455A64"
        />
        <path
          d="M191.557 146.077V145.843L197.894 142.184V142.419L191.557 146.077Z"
          fill="#455A64"
        />
        <path
          d="M191.595 148.013V147.779L197.933 144.121L197.932 144.355L191.595 148.013Z"
          fill="#455A64"
        />
        <path
          d="M191.571 151.869V151.635L197.908 147.976V148.21L191.571 151.869Z"
          fill="#455A64"
        />
        <path
          d="M191.577 153.97V153.736L197.913 150.077V150.311L191.577 153.97Z"
          fill="#455A64"
        />
        <path
          d="M191.605 155.465V155.23L197.942 151.572L197.942 151.806L191.605 155.465Z"
          fill="#455A64"
        />
        <path
          d="M191.559 157.54V157.306L197.896 153.647L197.896 153.882L191.559 157.54Z"
          fill="#455A64"
        />
        <path
          d="M191.564 145.255L191.563 144.786L197.901 141.128L197.9 141.596L191.564 145.255Z"
          fill="#455A64"
        />
        <path
          d="M182.579 158.648L138.244 133.004L87.9028 162.14L132.238 187.784L182.579 158.648Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.3"
          d="M182.579 158.648L138.244 133.004L87.9028 162.14L132.238 187.784L182.579 158.648Z"
          fill="white"
        />
        <g opacity="0.2">
          <path
            d="M87.9028 162.14L129.023 185.924L174.832 159.412L133.712 135.627L87.9028 162.14Z"
            fill="black"
          />
        </g>
        <path
          d="M132.238 221.083L182.58 191.946V158.648L132.238 187.784V221.083Z"
          fill="#F28B0B"
        />
        <path
          d="M137.794 210.037C137.639 210.037 137.493 210 137.361 209.923C137.018 209.724 136.82 209.288 136.82 208.726V205.198C136.82 205.196 136.82 205.194 136.82 205.191V204.931L137 204.963L139.767 203.338V207.281C139.767 208.283 139.168 209.415 138.404 209.855C138.196 209.976 137.988 210.037 137.794 210.037ZM137.263 205.459V208.725C137.263 209.124 137.381 209.421 137.583 209.538C137.784 209.654 138.019 209.564 138.182 209.472C138.8 209.113 139.323 208.111 139.323 207.281V206.992H138.299L138.096 205.609L137.263 205.459ZM138.682 206.547H139.323V204.112L137.673 205.081L138.49 205.227L138.682 206.547Z"
          fill="#455A64"
        />
        <path
          d="M138.293 212.849C138.171 212.849 138.072 212.75 138.072 212.627V209.664C138.072 209.541 138.171 209.442 138.293 209.442C138.416 209.442 138.514 209.541 138.514 209.664V212.627C138.514 212.75 138.416 212.849 138.293 212.849Z"
          fill="#455A64"
        />
        <path
          d="M137.005 213.593C136.929 213.593 136.853 213.554 136.813 213.482C136.751 213.375 136.787 213.24 136.894 213.179L139.47 211.693C139.574 211.629 139.713 211.665 139.773 211.774C139.835 211.88 139.799 212.015 139.693 212.076L137.116 213.563C137.081 213.583 137.043 213.593 137.005 213.593Z"
          fill="#455A64"
        />
        <path
          d="M146.184 208.489C146.098 208.489 146.015 208.468 145.941 208.427C145.773 208.33 145.676 208.136 145.676 207.893V207.286C145.676 207.163 145.775 207.064 145.898 207.064C146.02 207.064 146.12 207.163 146.12 207.286V207.893C146.12 207.984 146.145 208.032 146.163 208.042C146.18 208.051 146.232 208.048 146.307 208.004C146.502 207.888 146.719 207.448 146.719 207.001V203.06C146.719 202.937 146.818 202.838 146.941 202.838C147.063 202.838 147.163 202.937 147.163 203.06V207.001C147.163 207.578 146.892 208.174 146.533 208.385C146.415 208.454 146.296 208.489 146.184 208.489Z"
          fill="#455A64"
        />
        <path
          d="M143.847 205.043V204.658C143.847 202.851 145.12 200.646 146.684 199.743C147.485 199.282 148.249 199.214 148.834 199.552C149.422 199.891 149.744 200.586 149.744 201.509V201.638L143.847 205.043ZM148.013 199.785C147.678 199.785 147.302 199.9 146.906 200.129C145.578 200.895 144.477 202.682 144.313 204.263L149.298 201.383C149.273 200.69 149.031 200.179 148.613 199.937C148.436 199.834 148.234 199.785 148.013 199.785Z"
          fill="#455A64"
        />
        <path
          d="M154.15 203.947C154.027 203.947 153.928 203.848 153.928 203.725V196.176C153.928 196.054 154.027 195.955 154.15 195.955C154.272 195.955 154.371 196.054 154.371 196.176V203.725C154.371 203.848 154.272 203.947 154.15 203.947Z"
          fill="#455A64"
        />
        <path
          d="M153.501 197.898C153.471 197.898 153.443 197.892 153.413 197.879C153.3 197.83 153.249 197.7 153.297 197.587L154.086 195.764L154.967 196.78C155.048 196.873 155.038 197.013 154.945 197.092C154.85 197.173 154.712 197.163 154.632 197.07L154.213 196.587L153.704 197.763C153.669 197.847 153.587 197.898 153.501 197.898Z"
          fill="#455A64"
        />
        <path
          d="M156.202 202.778C156.079 202.778 155.98 202.678 155.98 202.556V195.006C155.98 194.884 156.079 194.785 156.202 194.785C156.323 194.785 156.423 194.884 156.423 195.006V202.556C156.424 202.678 156.324 202.778 156.202 202.778Z"
          fill="#455A64"
        />
        <path
          d="M155.552 196.728C155.522 196.728 155.493 196.722 155.464 196.71C155.351 196.661 155.3 196.53 155.348 196.418L156.138 194.594L157.018 195.611C157.1 195.703 157.089 195.843 156.997 195.923C156.902 196.003 156.763 195.994 156.683 195.901L156.265 195.418L155.756 196.594C155.72 196.678 155.638 196.728 155.552 196.728Z"
          fill="#455A64"
        />
        <path
          d="M132.238 221.083L87.9028 195.438V162.14L132.238 187.784V221.083Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.1"
          d="M132.238 221.083L87.9028 195.438V162.14L132.238 187.784V221.083Z"
          fill="black"
        />
        <g opacity="0.2">
          <path
            d="M87.9028 173.268L129.023 197.053V185.924L87.9028 162.14V173.268Z"
            fill="black"
          />
        </g>
        <path
          d="M107.902 178.745L111.162 180.627V175.568L107.902 173.686V178.745Z"
          fill="#37474F"
        />
        <path
          d="M111.162 175.569L161.503 146.432L158.242 144.549L107.902 173.686L111.162 175.569Z"
          fill="#455A64"
        />
        <path
          d="M94.2468 183.092L105.771 189.749C106.057 189.915 106.291 190.32 106.291 190.65L106.292 198.661C106.292 199.321 105.825 199.591 105.253 199.26L93.7272 192.603C93.4414 192.438 93.2075 192.033 93.2075 191.703V183.691C93.2075 183.032 93.6753 182.762 94.2468 183.092Z"
          fill="#FAFAFA"
        />
        <path
          d="M93.9595 184.339L94.352 184.565L94.3513 191.636L93.9595 191.41V184.339Z"
          fill="#455A64"
        />
        <path
          d="M95.5559 185.26L96.2312 185.657V192.728L95.5559 192.331V185.26Z"
          fill="#455A64"
        />
        <path
          d="M97.1516 186.181L97.5442 186.407L97.5434 193.478L97.1516 193.252V186.181Z"
          fill="#455A64"
        />
        <path
          d="M98.3557 186.863L99.14 187.328V194.4L98.3557 193.934V186.863Z"
          fill="#455A64"
        />
        <path
          d="M100.345 188.023L100.737 188.249V195.321L100.345 195.094V188.023Z"
          fill="#455A64"
        />
        <path
          d="M101.494 188.672L102.333 189.17L102.332 196.242L101.494 195.743V188.672Z"
          fill="#455A64"
        />
        <path
          d="M103.537 189.865L103.929 190.092V197.163L103.537 196.937V189.865Z"
          fill="#455A64"
        />
        <path
          d="M104.448 190.384L104.644 190.497L104.643 197.568L104.448 197.455V190.384Z"
          fill="#455A64"
        />
        <path
          d="M102.809 189.48L103.005 189.593V196.665L102.809 196.551V189.48Z"
          fill="#455A64"
        />
        <path
          d="M99.5942 187.597L99.7898 187.71V194.781L99.5942 194.668V187.597Z"
          fill="#455A64"
        />
        <path
          d="M97.833 186.586L98.0285 186.7V193.771L97.833 193.658V186.586Z"
          fill="#455A64"
        />
        <path
          d="M96.5681 185.888L96.7644 186.001L96.7636 193.072L96.5681 192.959V185.888Z"
          fill="#455A64"
        />
        <path
          d="M94.8528 184.847L95.0491 184.96V192.031L94.8528 191.918V184.847Z"
          fill="#455A64"
        />
        <path
          d="M105.133 190.786L105.525 191.013V198.084L105.133 197.858L105.133 190.786Z"
          fill="#455A64"
        />
        <path
          d="M169.129 126.154L124.794 100.509L74.4534 129.646L118.788 155.29L169.129 126.154Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.7"
          d="M169.129 126.154L124.794 100.509L74.4534 129.646L118.788 155.29L169.129 126.154Z"
          fill="white"
        />
        <path
          d="M118.789 188.589L169.129 159.453V126.154L118.788 155.29L118.789 188.589Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.6"
          d="M118.789 188.589L169.129 159.453V126.154L118.788 155.29L118.789 188.589Z"
          fill="white"
        />
        <path
          d="M124.345 177.543C124.19 177.543 124.044 177.505 123.911 177.429C123.568 177.231 123.37 176.794 123.37 176.232V172.704C123.37 172.702 123.37 172.7 123.37 172.698V172.437L123.55 172.468L126.317 170.844V174.786C126.317 175.788 125.718 176.92 124.954 177.361C124.747 177.483 124.538 177.543 124.345 177.543ZM123.814 172.965V176.232C123.814 176.631 123.931 176.928 124.133 177.045C124.334 177.161 124.57 177.072 124.733 176.979C125.351 176.62 125.874 175.618 125.874 174.787V174.497H124.85L124.647 173.114L123.814 172.965ZM125.233 174.053H125.874V171.618L124.223 172.587L125.041 172.733L125.233 174.053Z"
          fill="#455A64"
        />
        <path
          d="M124.843 180.355C124.721 180.355 124.622 180.256 124.622 180.133V177.17C124.622 177.047 124.721 176.948 124.843 176.948C124.966 176.948 125.065 177.047 125.065 177.17V180.133C125.065 180.256 124.966 180.355 124.843 180.355Z"
          fill="#455A64"
        />
        <path
          d="M123.555 181.099C123.479 181.099 123.403 181.06 123.363 180.988C123.302 180.882 123.337 180.746 123.443 180.685L126.02 179.198C126.125 179.135 126.262 179.171 126.323 179.279C126.384 179.386 126.349 179.52 126.242 179.581L123.665 181.069C123.632 181.089 123.594 181.099 123.555 181.099Z"
          fill="#455A64"
        />
        <path
          d="M132.734 175.995C132.648 175.995 132.566 175.974 132.491 175.933C132.322 175.836 132.226 175.642 132.226 175.399V174.791C132.226 174.669 132.325 174.569 132.448 174.569C132.57 174.569 132.67 174.669 132.67 174.791V175.399C132.67 175.49 132.695 175.537 132.712 175.548C132.729 175.557 132.781 175.554 132.856 175.51C133.052 175.394 133.269 174.954 133.269 174.507V170.566C133.269 170.443 133.368 170.344 133.491 170.344C133.613 170.344 133.713 170.443 133.713 170.566V174.507C133.713 175.084 133.443 175.679 133.082 175.891C132.966 175.96 132.846 175.995 132.734 175.995Z"
          fill="#455A64"
        />
        <path
          d="M130.398 172.549V172.165C130.398 170.358 131.671 168.152 133.235 167.249C134.036 166.788 134.801 166.72 135.385 167.058C135.972 167.397 136.295 168.092 136.295 169.015V169.144L130.398 172.549ZM134.564 167.291C134.228 167.291 133.852 167.406 133.457 167.634C132.128 168.401 131.027 170.188 130.863 171.769L135.849 168.889C135.823 168.195 135.582 167.685 135.164 167.443C134.986 167.34 134.784 167.291 134.564 167.291Z"
          fill="#455A64"
        />
        <path
          d="M140.7 171.453C140.578 171.453 140.478 171.354 140.478 171.231V163.683C140.478 163.56 140.578 163.461 140.7 163.461C140.823 163.461 140.922 163.56 140.922 163.683V171.231C140.922 171.354 140.823 171.453 140.7 171.453Z"
          fill="#455A64"
        />
        <path
          d="M140.052 165.404C140.022 165.404 139.993 165.398 139.964 165.386C139.851 165.337 139.8 165.207 139.848 165.094L140.638 163.271L141.518 164.288C141.599 164.38 141.589 164.52 141.497 164.601C141.402 164.68 141.263 164.671 141.183 164.578L140.765 164.095L140.255 165.272C140.22 165.353 140.138 165.404 140.052 165.404Z"
          fill="#455A64"
        />
        <path
          d="M142.752 170.283C142.63 170.283 142.531 170.184 142.531 170.061V162.512C142.531 162.389 142.63 162.29 142.752 162.29C142.875 162.29 142.974 162.389 142.974 162.512V170.061C142.974 170.184 142.875 170.283 142.752 170.283Z"
          fill="#455A64"
        />
        <path
          d="M142.103 164.234C142.073 164.234 142.044 164.228 142.015 164.216C141.903 164.167 141.852 164.036 141.9 163.924L142.689 162.1L143.569 163.117C143.65 163.21 143.64 163.349 143.547 163.429C143.453 163.508 143.314 163.5 143.234 163.407L142.816 162.925L142.307 164.101C142.27 164.183 142.188 164.234 142.103 164.234Z"
          fill="#455A64"
        />
        <path
          d="M118.788 188.589L74.4534 162.944V129.646L118.788 155.29V188.589Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.4"
          d="M118.788 188.589L74.4534 162.944V129.646L118.788 155.29V188.589Z"
          fill="white"
        />
        <path
          d="M91.2891 144.437L99.2106 149.028V143.968L91.2891 139.378V144.437Z"
          fill="#37474F"
        />
        <path
          d="M99.2106 143.969L149.552 114.833L141.629 110.242L91.2891 139.378L99.2106 143.969Z"
          fill="#455A64"
        />
        <path
          d="M80.7966 150.598L92.321 157.255C92.6075 157.421 92.8414 157.826 92.8414 158.155L92.8421 166.167C92.8421 166.827 92.3744 167.097 91.8036 166.767L80.2777 160.109C79.9919 159.944 79.7581 159.539 79.7581 159.209V151.197C79.7581 150.538 80.2258 150.268 80.7966 150.598Z"
          fill="#FAFAFA"
        />
        <path
          d="M80.51 151.845L80.9018 152.071V159.142L80.51 158.916V151.845Z"
          fill="#455A64"
        />
        <path
          d="M82.1057 152.765L82.7818 153.163V160.234L82.1057 159.837V152.765Z"
          fill="#455A64"
        />
        <path
          d="M83.7021 153.686L84.0939 153.913V160.984L83.7021 160.758V153.686Z"
          fill="#455A64"
        />
        <path
          d="M84.9063 154.368L85.6914 154.835L85.6906 161.906L84.9055 161.44L84.9063 154.368Z"
          fill="#455A64"
        />
        <path
          d="M86.8945 155.529L87.2871 155.756L87.2863 162.827L86.8945 162.6V155.529Z"
          fill="#455A64"
        />
        <path
          d="M88.0442 156.178L88.8827 156.676V163.747L88.0442 163.249V156.178Z"
          fill="#455A64"
        />
        <path
          d="M90.0874 157.371L90.4792 157.598L90.4785 164.669L90.0867 164.443L90.0874 157.371Z"
          fill="#455A64"
        />
        <path
          d="M90.9973 157.89L91.1936 158.003V165.074L90.9973 164.961V157.89Z"
          fill="#455A64"
        />
        <path
          d="M89.3596 156.986L89.5559 157.1L89.5551 164.171L89.3596 164.057V156.986Z"
          fill="#455A64"
        />
        <path
          d="M86.144 155.102L86.3396 155.216V162.287L86.144 162.174V155.102Z"
          fill="#455A64"
        />
        <path
          d="M84.3828 154.092L84.5798 154.205V161.277L84.3828 161.163V154.092Z"
          fill="#455A64"
        />
        <path
          d="M83.1187 153.394L83.3149 153.507L83.3142 160.578L83.1187 160.465V153.394Z"
          fill="#455A64"
        />
        <path
          d="M81.4033 152.352L81.5988 152.466V159.537L81.4033 159.424V152.352Z"
          fill="#455A64"
        />
        <path
          d="M91.6831 158.292L92.0757 158.519L92.0749 165.59L91.6831 165.363V158.292Z"
          fill="#455A64"
        />
        <path
          d="M254.189 156.957L206.322 129.27L151.971 160.728L199.837 188.415L254.189 156.957Z"
          fill="#F28B0B"
        />
        <g opacity="0.4">
          <path
            d="M254.189 156.957L206.322 129.27L151.971 160.728L199.837 188.415L254.189 156.957Z"
            fill="white"
          />
        </g>
        <path
          d="M199.838 247.453L254.189 215.995V156.957L199.838 188.415V247.453Z"
          fill="#F28B0B"
        />
        <g opacity="0.2">
          <path
            d="M199.838 247.453L254.189 215.995V156.957L199.838 188.415V247.453Z"
            fill="white"
          />
        </g>
        <path
          d="M204.542 237.424C204.413 237.424 204.291 237.393 204.18 237.329C203.893 237.162 203.727 236.797 203.727 236.327V233.373C203.727 233.371 203.727 233.369 203.727 233.367V233.148L203.878 233.175L206.195 231.815V235.116C206.195 235.956 205.694 236.903 205.055 237.273C204.879 237.373 204.705 237.424 204.542 237.424ZM204.099 233.591V236.327C204.099 236.66 204.197 236.909 204.366 237.007C204.534 237.103 204.731 237.029 204.867 236.951C205.385 236.651 205.822 235.811 205.822 235.116V234.874H204.965L204.796 233.716L204.099 233.591ZM205.287 234.503H205.823V232.463L204.442 233.275L205.125 233.397L205.287 234.503Z"
          fill="#455A64"
        />
        <path
          d="M204.961 239.78C204.858 239.78 204.775 239.696 204.775 239.594V237.112C204.775 237.009 204.858 236.927 204.961 236.927C205.063 236.927 205.146 237.01 205.146 237.112V239.594C205.146 239.696 205.064 239.78 204.961 239.78Z"
          fill="#455A64"
        />
        <path
          d="M203.881 240.402C203.818 240.402 203.755 240.369 203.721 240.31C203.669 240.22 203.7 240.108 203.789 240.056L205.946 238.81C206.034 238.757 206.149 238.787 206.2 238.878C206.252 238.967 206.222 239.08 206.132 239.131L203.975 240.377C203.945 240.394 203.914 240.402 203.881 240.402Z"
          fill="#455A64"
        />
        <path
          d="M211.568 236.128C211.496 236.128 211.427 236.111 211.365 236.075C211.225 235.994 211.143 235.832 211.143 235.629V235.12C211.143 235.017 211.226 234.934 211.329 234.934C211.432 234.934 211.514 235.017 211.514 235.12V235.629C211.514 235.705 211.535 235.744 211.55 235.754C211.565 235.761 211.608 235.758 211.671 235.721C211.835 235.625 212.017 235.256 212.017 234.881V231.581C212.017 231.478 212.1 231.395 212.202 231.395C212.305 231.395 212.388 231.478 212.388 231.581V234.881C212.388 235.365 212.162 235.863 211.861 236.041C211.762 236.099 211.662 236.128 211.568 236.128Z"
          fill="#455A64"
        />
        <path
          d="M209.612 233.243V232.921C209.612 231.408 210.677 229.562 211.987 228.806C212.658 228.419 213.298 228.363 213.788 228.646C214.279 228.93 214.55 229.512 214.55 230.284V230.392L209.612 233.243ZM213.1 228.839C212.819 228.839 212.504 228.935 212.173 229.127C211.06 229.768 210.138 231.265 210.001 232.588L214.176 230.177C214.155 229.596 213.952 229.169 213.602 228.967C213.454 228.881 213.285 228.839 213.1 228.839Z"
          fill="#455A64"
        />
        <path
          d="M218.239 232.325C218.136 232.325 218.053 232.242 218.053 232.139V225.818C218.053 225.716 218.136 225.632 218.239 225.632C218.341 225.632 218.424 225.716 218.424 225.818V232.139C218.424 232.242 218.341 232.325 218.239 232.325Z"
          fill="#455A64"
        />
        <path
          d="M217.696 227.26C217.67 227.26 217.646 227.254 217.622 227.244C217.527 227.203 217.484 227.093 217.526 226.999L218.186 225.473L218.923 226.324C218.991 226.402 218.982 226.519 218.905 226.586C218.826 226.653 218.709 226.645 218.642 226.567L218.293 226.162L217.866 227.148C217.836 227.218 217.767 227.26 217.696 227.26Z"
          fill="#455A64"
        />
        <path
          d="M219.957 231.346C219.855 231.346 219.771 231.263 219.771 231.16V224.839C219.771 224.736 219.855 224.653 219.957 224.653C220.059 224.653 220.143 224.736 220.143 224.839V231.16C220.143 231.263 220.059 231.346 219.957 231.346Z"
          fill="#455A64"
        />
        <path
          d="M219.412 226.28C219.388 226.28 219.363 226.275 219.339 226.265C219.244 226.224 219.202 226.114 219.242 226.02L219.903 224.494L220.64 225.345C220.708 225.423 220.699 225.54 220.622 225.607C220.543 225.673 220.427 225.666 220.36 225.588L220.01 225.183L219.583 226.168C219.553 226.238 219.485 226.28 219.412 226.28Z"
          fill="#455A64"
        />
        <path
          d="M199.838 247.453L151.971 219.766V160.728L199.837 188.415L199.838 247.453Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.15"
          d="M199.838 247.453L151.971 219.766V160.728L199.837 188.415L199.838 247.453Z"
          fill="black"
        />
        <path
          d="M231.434 177.219L222.658 182.298V175.207L231.434 170.128V177.219Z"
          fill="#37474F"
        />
        <path
          d="M222.658 175.207L174.806 147.512L183.582 142.432L231.434 170.127L222.658 175.207Z"
          fill="#455A64"
        />
        <path
          d="M155.432 211.811L163.71 216.594C163.916 216.713 164.084 217.004 164.084 217.242L164.085 222.997C164.085 223.47 163.749 223.664 163.339 223.427L155.059 218.645C154.853 218.527 154.686 218.236 154.686 217.999V212.243C154.686 211.768 155.022 211.574 155.432 211.811Z"
          fill="#FAFAFA"
        />
        <path
          d="M155.226 212.707L155.508 212.869V217.95L155.226 217.787V212.707Z"
          fill="#455A64"
        />
        <path
          d="M156.372 213.369L156.857 213.654V218.734L156.372 218.448V213.369Z"
          fill="#455A64"
        />
        <path
          d="M157.519 214.03L157.801 214.193L157.801 219.273L157.519 219.11V214.03Z"
          fill="#455A64"
        />
        <path
          d="M158.384 214.521L158.947 214.855V219.934L158.384 219.601V214.521Z"
          fill="#455A64"
        />
        <path
          d="M159.812 215.354L160.094 215.516V220.597L159.812 220.434V215.354Z"
          fill="#455A64"
        />
        <path
          d="M160.638 215.82L161.241 216.178V221.259L160.638 220.9V215.82Z"
          fill="#455A64"
        />
        <path
          d="M162.106 216.678L162.388 216.84V221.92L162.106 221.757V216.678Z"
          fill="#455A64"
        />
        <path
          d="M162.76 217.05L162.901 217.131L162.9 222.211L162.76 222.13V217.05Z"
          fill="#455A64"
        />
        <path
          d="M161.583 216.401L161.724 216.482V221.562L161.583 221.481V216.401Z"
          fill="#455A64"
        />
        <path
          d="M159.273 215.048L159.414 215.129L159.414 220.209L159.273 220.128V215.048Z"
          fill="#455A64"
        />
        <path
          d="M158.008 214.322L158.149 214.403V219.483L158.008 219.402V214.322Z"
          fill="#455A64"
        />
        <path
          d="M157.1 213.82L157.24 213.902V218.981L157.1 218.9V213.82Z"
          fill="#455A64"
        />
        <path
          d="M155.868 213.072L156.008 213.154V218.233L155.868 218.152V213.072Z"
          fill="#455A64"
        />
        <path
          d="M163.252 217.339L163.534 217.502L163.534 222.581L163.252 222.419V217.339Z"
          fill="#455A64"
        />
        <path
          d="M202.014 183.235C201.95 183.235 201.886 183.22 201.829 183.187L55.2946 100.357C55.1142 100.254 55.0502 100.025 55.1525 99.8446C55.2548 99.6634 55.4842 99.6009 55.6654 99.7025L202.011 182.426L276.844 139.222C277.023 139.118 277.253 139.179 277.357 139.359C277.462 139.539 277.4 139.769 277.22 139.873L202.202 183.184C202.143 183.219 202.078 183.235 202.014 183.235Z"
          fill="#E0E0E0"
        />
        <path
          d="M184.702 259.864C184.637 259.864 184.572 259.847 184.514 259.814L74.8707 196.511C74.7774 196.458 74.712 196.367 74.6902 196.261L55.1111 100.105C55.0698 99.9017 55.2014 99.7024 55.4051 99.6618C55.6052 99.6189 55.8067 99.7513 55.8488 99.9551L75.3941 195.945L184.703 259.054L259.39 215.933L276.665 139.464C276.71 139.263 276.909 139.134 277.115 139.181C277.318 139.227 277.445 139.428 277.399 139.631L260.087 216.259C260.065 216.361 260 216.449 259.909 216.501L184.891 259.813C184.832 259.847 184.766 259.864 184.702 259.864Z"
          fill="#E0E0E0"
        />
        <path
          d="M184.702 259.864C184.675 259.864 184.647 259.861 184.619 259.854C184.416 259.808 184.29 259.608 184.336 259.405L201.647 182.777C201.692 182.574 201.89 182.444 202.097 182.493C202.3 182.539 202.427 182.74 202.381 182.943L185.069 259.571C185.03 259.746 184.874 259.864 184.702 259.864Z"
          fill="#E0E0E0"
        />
        <path
          d="M203.457 249.036C203.43 249.036 203.402 249.033 203.374 249.026C203.171 248.98 203.044 248.78 203.09 248.577L220.402 171.948C220.447 171.745 220.646 171.618 220.851 171.664C221.054 171.71 221.181 171.912 221.135 172.114L203.823 248.743C203.784 248.918 203.628 249.036 203.457 249.036Z"
          fill="#E0E0E0"
        />
        <path
          d="M222.21 238.208C222.183 238.208 222.155 238.205 222.127 238.198C221.924 238.152 221.798 237.952 221.844 237.749L239.156 161.12C239.201 160.918 239.402 160.791 239.605 160.836C239.808 160.882 239.935 161.084 239.889 161.286L222.577 237.914C222.538 238.09 222.382 238.208 222.21 238.208Z"
          fill="#E0E0E0"
        />
        <path
          d="M240.964 227.38C240.937 227.38 240.909 227.377 240.882 227.37C240.678 227.325 240.551 227.124 240.598 226.92L257.909 150.292C257.954 150.09 258.152 149.963 258.359 150.008C258.562 150.054 258.688 150.256 258.642 150.458L241.33 227.087C241.292 227.262 241.136 227.38 240.964 227.38Z"
          fill="#E0E0E0"
        />
        <path
          d="M88.764 204.475C88.576 204.475 88.4135 204.333 88.391 204.143L77.6509 112.818C77.6261 112.612 77.7735 112.425 77.9803 112.401C78.1931 112.374 78.3736 112.524 78.3984 112.73L89.1385 204.055C89.1633 204.262 89.0159 204.448 88.8091 204.473C88.7933 204.474 88.779 204.475 88.764 204.475Z"
          fill="#E0E0E0"
        />
        <path
          d="M102.47 212.387C102.274 212.387 102.109 212.235 102.095 212.037L95.9448 123.141C95.9305 122.934 96.0869 122.753 96.2944 122.739C96.4952 122.728 96.681 122.881 96.6953 123.088L102.846 211.985C102.859 212.192 102.704 212.372 102.496 212.386C102.487 212.387 102.478 212.387 102.47 212.387Z"
          fill="#E0E0E0"
        />
        <path
          d="M116.175 220.301C115.969 220.301 115.801 220.134 115.799 219.928L115.115 133.955C115.113 133.748 115.28 133.578 115.488 133.576C115.663 133.583 115.865 133.742 115.867 133.949L116.551 219.922C116.553 220.129 116.386 220.299 116.178 220.301H116.175Z"
          fill="#E0E0E0"
        />
        <path
          d="M129.881 228.213C129.877 228.213 129.871 228.213 129.867 228.213C129.659 228.205 129.498 228.031 129.505 227.823L132.622 143.834C132.631 143.627 132.821 143.462 133.012 143.473C133.22 143.48 133.382 143.655 133.374 143.862L130.257 227.851C130.249 228.054 130.082 228.213 129.881 228.213Z"
          fill="#E0E0E0"
        />
        <path
          d="M143.586 236.126C143.576 236.126 143.566 236.125 143.556 236.124C143.349 236.108 143.194 235.927 143.211 235.72L149.704 153.473C149.719 153.266 149.912 153.115 150.108 153.128C150.314 153.144 150.469 153.325 150.453 153.532L143.96 235.779C143.945 235.976 143.78 236.126 143.586 236.126Z"
          fill="#E0E0E0"
        />
        <path
          d="M157.292 244.039C157.276 244.039 157.261 244.038 157.245 244.036C157.039 244.01 156.893 243.822 156.918 243.616L167.017 163.241C167.043 163.035 167.237 162.891 167.437 162.915C167.643 162.94 167.789 163.129 167.764 163.335L157.664 243.71C157.64 243.9 157.479 244.039 157.292 244.039Z"
          fill="#E0E0E0"
        />
        <path
          d="M170.998 251.951C170.976 251.951 170.953 251.949 170.93 251.945C170.725 251.907 170.591 251.712 170.627 251.508L184.843 173.045C184.88 172.84 185.079 172.707 185.28 172.742C185.485 172.779 185.62 172.975 185.583 173.179L171.367 251.642C171.334 251.824 171.176 251.951 170.998 251.951Z"
          fill="#E0E0E0"
        />
        <path
          d="M202.014 183.235C201.95 183.235 201.886 183.22 201.829 183.187L55.2946 100.357C55.1142 100.254 55.0502 100.025 55.1525 99.8446C55.2548 99.6634 55.4842 99.6009 55.6654 99.7025L202.011 182.426L276.844 139.222C277.023 139.118 277.253 139.179 277.357 139.359C277.462 139.539 277.4 139.769 277.22 139.873L202.202 183.184C202.143 183.219 202.078 183.235 202.014 183.235Z"
          fill="#E0E0E0"
        />
        <path
          d="M197.686 202.393C197.621 202.393 197.556 202.375 197.498 202.343L60.1607 123.441C59.981 123.337 59.9186 123.108 60.0216 122.927C60.1254 122.746 60.3555 122.685 60.5352 122.788L197.685 201.582L272.516 158.379C272.695 158.274 272.926 158.336 273.029 158.516C273.134 158.696 273.072 158.926 272.892 159.03L197.874 202.341C197.816 202.375 197.75 202.393 197.686 202.393Z"
          fill="#E0E0E0"
        />
        <path
          d="M193.358 221.55C193.293 221.55 193.229 221.533 193.171 221.5L65.0825 147.745C64.902 147.642 64.8404 147.412 64.9434 147.232C65.0472 147.051 65.2773 146.99 65.457 147.093L193.358 220.739L268.188 177.536C268.367 177.432 268.598 177.493 268.702 177.674C268.806 177.853 268.744 178.083 268.564 178.187L193.546 221.499C193.488 221.532 193.423 221.55 193.358 221.55Z"
          fill="#E0E0E0"
        />
        <path
          d="M189.03 240.707C188.964 240.707 188.899 240.69 188.841 240.657L69.9038 171.505C69.724 171.4 69.6631 171.17 69.7669 170.991C69.8714 170.811 70.1023 170.751 70.2813 170.854L189.03 239.896L263.86 196.693C264.039 196.588 264.27 196.65 264.374 196.831C264.479 197.01 264.417 197.241 264.236 197.344L189.218 240.657C189.16 240.69 189.094 240.707 189.03 240.707Z"
          fill="#E0E0E0"
        />
        <path
          d="M184.702 259.864C184.637 259.864 184.572 259.847 184.514 259.814L74.8706 196.511C74.6909 196.407 74.6292 196.178 74.733 195.998C74.836 195.818 75.0669 195.757 75.2466 195.86L184.702 259.053L259.533 215.85C259.712 215.745 259.943 215.807 260.046 215.988C260.151 216.168 260.089 216.398 259.909 216.502L184.89 259.814C184.832 259.847 184.766 259.864 184.702 259.864Z"
          fill="#E0E0E0"
        />
        <path
          d="M226.218 271.434L273.374 244.159L326.917 275.149L279.761 302.424L226.218 271.434Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.7"
          d="M226.218 271.434L273.374 244.159L326.917 275.149L279.761 302.424L226.218 271.434Z"
          fill="white"
        />
        <g opacity="0.2">
          <path
            d="M326.917 275.149L283.181 300.447L234.458 272.247L278.193 246.949L326.917 275.149Z"
            fill="black"
          />
        </g>
        <path
          d="M279.761 337.841L226.217 306.851V271.434L279.761 302.424V337.841Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.6"
          d="M279.761 337.841L226.217 306.851V271.434L279.761 302.424V337.841Z"
          fill="white"
        />
        <path
          d="M273.203 325.9C272.391 325.431 271.754 324.228 271.754 323.161V318.968L274.696 320.696L274.888 320.662V320.939C274.888 320.942 274.888 320.945 274.888 320.946V324.699C274.888 325.296 274.678 325.76 274.312 325.972C274.172 326.054 274.017 326.094 273.852 326.094C273.645 326.093 273.423 326.028 273.203 325.9ZM273.529 321.383L273.315 322.854H272.226V323.161C272.226 324.045 272.782 325.111 273.439 325.493C273.612 325.591 273.863 325.685 274.077 325.563C274.291 325.439 274.416 325.122 274.416 324.699V321.224L273.529 321.383ZM273.111 320.977L273.98 320.822L272.225 319.791V322.382H272.907L273.111 320.977Z"
          fill="#455A64"
        />
        <path
          d="M273.32 329.084C273.45 329.084 273.556 328.978 273.556 328.848V325.696C273.556 325.566 273.45 325.46 273.32 325.46C273.19 325.46 273.085 325.566 273.085 325.696V328.848C273.085 328.979 273.19 329.084 273.32 329.084Z"
          fill="#455A64"
        />
        <path
          d="M274.691 329.875C274.772 329.875 274.852 329.832 274.895 329.757C274.96 329.643 274.922 329.5 274.809 329.434L272.068 327.852C271.958 327.785 271.811 327.823 271.746 327.939C271.681 328.052 271.719 328.195 271.832 328.26L274.573 329.842C274.61 329.865 274.651 329.875 274.691 329.875Z"
          fill="#455A64"
        />
        <path
          d="M264.928 324.447C265.02 324.447 265.108 324.424 265.187 324.38C265.366 324.277 265.469 324.071 265.469 323.813V323.166C265.469 323.036 265.363 322.93 265.233 322.93C265.103 322.93 264.997 323.036 264.997 323.166V323.813C264.997 323.909 264.97 323.96 264.951 323.971C264.933 323.981 264.878 323.977 264.798 323.931C264.59 323.808 264.359 323.34 264.359 322.864V318.672C264.359 318.542 264.253 318.436 264.123 318.436C263.992 318.436 263.887 318.542 263.887 318.672V322.864C263.887 323.479 264.175 324.112 264.556 324.337C264.682 324.409 264.808 324.447 264.928 324.447Z"
          fill="#455A64"
        />
        <path
          d="M261.141 317.159V317.022C261.141 316.041 261.484 315.302 262.108 314.941C262.73 314.581 263.544 314.653 264.396 315.144C266.06 316.105 267.413 318.45 267.413 320.372V320.781L261.141 317.159ZM262.344 315.35C261.9 315.607 261.642 316.15 261.615 316.888L266.918 319.951C266.744 318.27 265.572 316.369 264.159 315.554C263.738 315.311 263.338 315.188 262.982 315.188C262.748 315.188 262.533 315.241 262.344 315.35Z"
          fill="#455A64"
        />
        <path
          d="M256.455 319.615C256.585 319.615 256.691 319.509 256.691 319.379V311.351C256.691 311.22 256.585 311.114 256.455 311.114C256.325 311.114 256.22 311.22 256.22 311.351V319.38C256.22 319.51 256.325 319.615 256.455 319.615Z"
          fill="#455A64"
        />
        <path
          d="M257.145 313.182C257.177 313.182 257.207 313.175 257.238 313.162C257.358 313.11 257.413 312.971 257.361 312.852L256.521 310.912L255.585 311.994C255.499 312.092 255.51 312.241 255.608 312.326C255.709 312.411 255.857 312.4 255.942 312.302L256.386 311.788L256.927 313.04C256.967 313.128 257.054 313.182 257.145 313.182Z"
          fill="#455A64"
        />
        <path
          d="M254.272 318.372C254.402 318.372 254.508 318.266 254.508 318.136V310.106C254.508 309.975 254.402 309.87 254.272 309.87C254.142 309.87 254.036 309.975 254.036 310.106V318.136C254.037 318.265 254.143 318.372 254.272 318.372Z"
          fill="#455A64"
        />
        <path
          d="M254.963 311.937C254.995 311.937 255.026 311.931 255.056 311.918C255.177 311.866 255.231 311.727 255.179 311.607L254.34 309.668L253.404 310.749C253.317 310.848 253.329 310.996 253.427 311.081C253.528 311.166 253.676 311.157 253.76 311.057L254.205 310.544L254.747 311.795C254.785 311.884 254.872 311.937 254.963 311.937Z"
          fill="#455A64"
        />
        <path
          d="M279.761 337.841L326.917 310.565V275.149L279.761 302.424V337.841Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.4"
          d="M279.761 337.841L326.917 310.565V275.149L279.761 302.424V337.841Z"
          fill="white"
        />
        <g opacity="0.2">
          <path
            d="M326.917 286.985L283.18 312.282V300.447L326.917 275.149V286.985Z"
            fill="black"
          />
        </g>
        <path
          d="M305.646 292.81L302.178 294.813V289.431L305.646 287.429V292.81Z"
          fill="#37474F"
        />
        <path
          d="M302.178 289.431L248.635 258.441L252.103 256.439L305.646 287.429L302.178 289.431Z"
          fill="#455A64"
        />
        <path
          d="M320.17 297.433L307.912 304.514C307.609 304.689 307.36 305.121 307.36 305.472L307.359 313.993C307.359 314.695 307.856 314.982 308.464 314.631L320.723 307.551C321.027 307.375 321.275 306.945 321.275 306.593V298.072C321.275 297.37 320.777 297.083 320.17 297.433Z"
          fill="#FAFAFA"
        />
        <path
          d="M320.475 298.759L320.058 299V306.521L320.475 306.281V298.759Z"
          fill="#455A64"
        />
        <path
          d="M318.777 299.739L318.058 300.162V307.683L318.777 307.26V299.739Z"
          fill="#455A64"
        />
        <path
          d="M317.079 300.719L316.662 300.959L316.663 308.481L317.079 308.24V300.719Z"
          fill="#455A64"
        />
        <path
          d="M315.799 301.444L314.965 301.939V309.461L315.799 308.966V301.444Z"
          fill="#455A64"
        />
        <path
          d="M313.684 302.679L313.267 302.919V310.441L313.684 310.199V302.679Z"
          fill="#455A64"
        />
        <path
          d="M312.461 303.369L311.569 303.899L311.569 311.42L312.461 310.89V303.369Z"
          fill="#455A64"
        />
        <path
          d="M310.288 304.637L309.871 304.879V312.4L310.288 312.159V304.637Z"
          fill="#455A64"
        />
        <path
          d="M309.319 305.189L309.111 305.31V312.83L309.319 312.71V305.189Z"
          fill="#455A64"
        />
        <path
          d="M311.063 304.228L310.854 304.349V311.869L311.063 311.749V304.228Z"
          fill="#455A64"
        />
        <path
          d="M314.483 302.225L314.274 302.346L314.274 309.866L314.483 309.747V302.225Z"
          fill="#455A64"
        />
        <path
          d="M316.355 301.15L316.147 301.271V308.792L316.355 308.671V301.15Z"
          fill="#455A64"
        />
        <path
          d="M317.7 300.407L317.492 300.528V308.049L317.7 307.929V300.407Z"
          fill="#455A64"
        />
        <path
          d="M319.525 299.301L319.316 299.42L319.316 306.942L319.525 306.821V299.301Z"
          fill="#455A64"
        />
        <path
          d="M308.59 305.618L308.173 305.859L308.174 313.379L308.591 313.139L308.59 305.618Z"
          fill="#455A64"
        />
        <path
          d="M237.328 236.722L284.484 209.446L338.028 240.435L290.872 267.712L237.328 236.722Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.3"
          d="M237.328 236.722L284.484 209.446L338.028 240.435L290.872 267.712L237.328 236.722Z"
          fill="white"
        />
        <path
          d="M290.872 303.128L237.328 272.138V236.721L290.872 267.711V303.128Z"
          fill="#F28B0B"
        />
        <path
          d="M284.313 291.187C283.501 290.718 282.864 289.515 282.864 288.448V284.255L285.806 285.983L285.998 285.949V286.226C285.998 286.228 285.998 286.232 285.998 286.233V289.985C285.998 290.583 285.788 291.047 285.424 291.259C285.282 291.34 285.127 291.38 284.962 291.38C284.756 291.38 284.534 291.316 284.313 291.187ZM284.64 286.67L284.425 288.141H283.336V288.448C283.336 289.332 283.892 290.399 284.549 290.78C284.722 290.878 284.973 290.973 285.187 290.85C285.402 290.725 285.526 290.409 285.526 289.985V286.511L284.64 286.67ZM284.222 286.265L285.091 286.11L283.336 285.079V287.669H284.017L284.222 286.265Z"
          fill="#455A64"
        />
        <path
          d="M284.432 294.372C284.562 294.372 284.668 294.266 284.668 294.136V290.984C284.668 290.854 284.563 290.748 284.432 290.748C284.301 290.748 284.196 290.854 284.196 290.984V294.136C284.196 294.266 284.301 294.372 284.432 294.372Z"
          fill="#455A64"
        />
        <path
          d="M285.802 295.162C285.883 295.162 285.963 295.12 286.006 295.044C286.071 294.931 286.033 294.788 285.92 294.722L283.179 293.141C283.068 293.073 282.923 293.112 282.857 293.227C282.792 293.34 282.83 293.484 282.943 293.548L285.684 295.131C285.721 295.153 285.761 295.162 285.802 295.162Z"
          fill="#455A64"
        />
        <path
          d="M276.039 289.734C276.131 289.734 276.218 289.711 276.297 289.667C276.476 289.564 276.58 289.358 276.58 289.099V288.453C276.58 288.323 276.473 288.217 276.343 288.217C276.213 288.217 276.107 288.323 276.107 288.453V289.099C276.107 289.196 276.08 289.246 276.062 289.258C276.043 289.267 275.988 289.264 275.909 289.217C275.7 289.094 275.47 288.626 275.47 288.151V283.958C275.47 283.828 275.364 283.722 275.233 283.722C275.103 283.722 274.997 283.828 274.997 283.958V288.151C274.997 288.765 275.285 289.397 275.667 289.622C275.793 289.697 275.919 289.734 276.039 289.734Z"
          fill="#455A64"
        />
        <path
          d="M272.252 282.447V282.311C272.252 281.329 272.595 280.589 273.22 280.229C273.841 279.869 274.654 279.941 275.506 280.432C277.171 281.392 278.523 283.738 278.523 285.661V286.07L272.252 282.447ZM273.456 280.637C273.01 280.894 272.754 281.438 272.727 282.176L278.03 285.239C277.856 283.557 276.684 281.657 275.272 280.841C274.851 280.598 274.451 280.476 274.094 280.476C273.859 280.475 273.644 280.528 273.456 280.637Z"
          fill="#455A64"
        />
        <path
          d="M267.566 284.903C267.696 284.903 267.802 284.797 267.802 284.667V276.637C267.802 276.507 267.697 276.401 267.566 276.401C267.436 276.401 267.33 276.507 267.33 276.637V284.667C267.33 284.797 267.436 284.903 267.566 284.903Z"
          fill="#455A64"
        />
        <path
          d="M268.256 278.469C268.287 278.469 268.319 278.463 268.35 278.449C268.47 278.397 268.523 278.258 268.472 278.138L267.633 276.2L266.697 277.281C266.611 277.379 266.621 277.528 266.72 277.614C266.821 277.699 266.968 277.688 267.053 277.59L267.498 277.076L268.04 278.326C268.077 278.415 268.165 278.469 268.256 278.469Z"
          fill="#455A64"
        />
        <path
          d="M265.384 283.659C265.514 283.659 265.619 283.553 265.619 283.423V275.394C265.619 275.264 265.513 275.158 265.384 275.158C265.253 275.158 265.147 275.263 265.147 275.394V283.423C265.147 283.553 265.253 283.659 265.384 283.659Z"
          fill="#455A64"
        />
        <path
          d="M266.074 277.225C266.106 277.225 266.136 277.218 266.167 277.205C266.288 277.153 266.342 277.015 266.29 276.895L265.451 274.955L264.514 276.037C264.428 276.135 264.439 276.284 264.538 276.369C264.638 276.453 264.786 276.444 264.871 276.345L265.316 275.831L265.857 277.083C265.896 277.171 265.983 277.225 266.074 277.225Z"
          fill="#455A64"
        />
        <path
          d="M290.872 303.129L338.028 275.852V240.435L290.872 267.712V303.129Z"
          fill="#F28B0B"
        />
        <path
          opacity="0.1"
          d="M290.872 303.129L338.028 275.852V240.435L290.872 267.712V303.129Z"
          fill="black"
        />
        <path
          d="M316.757 258.098L313.29 260.1V254.718L316.757 252.716V258.098Z"
          fill="#37474F"
        />
        <path
          d="M313.29 254.719L259.746 223.729L263.214 221.726L316.757 252.716L313.29 254.719Z"
          fill="#455A64"
        />
        <path
          d="M331.281 262.721L319.023 269.802C318.719 269.977 318.47 270.409 318.47 270.76L318.469 279.281C318.469 279.982 318.966 280.27 319.574 279.918L331.833 272.838C332.137 272.662 332.386 272.232 332.386 271.881L332.386 263.359C332.386 262.657 331.888 262.37 331.281 262.721Z"
          fill="#FAFAFA"
        />
        <path
          d="M331.585 264.047L331.169 264.287V271.808L331.585 271.568V264.047Z"
          fill="#455A64"
        />
        <path
          d="M329.888 265.027L329.169 265.449L329.17 272.97L329.888 272.547V265.027Z"
          fill="#455A64"
        />
        <path
          d="M328.19 266.006L327.773 266.247V273.768L328.19 273.527V266.006Z"
          fill="#455A64"
        />
        <path
          d="M326.91 266.731L326.075 267.227V274.748L326.91 274.253V266.731Z"
          fill="#455A64"
        />
        <path
          d="M324.795 267.965L324.377 268.207L324.378 275.728L324.795 275.487V267.965Z"
          fill="#455A64"
        />
        <path
          d="M323.572 268.656L322.68 269.187V276.707L323.572 276.177V268.656Z"
          fill="#455A64"
        />
        <path
          d="M321.399 269.925L320.982 270.166L320.983 277.687L321.4 277.447L321.399 269.925Z"
          fill="#455A64"
        />
        <path
          d="M320.431 270.476L320.222 270.597V278.118L320.431 277.998V270.476Z"
          fill="#455A64"
        />
        <path
          d="M322.173 269.515L321.964 269.636L321.965 277.157L322.173 277.037V269.515Z"
          fill="#455A64"
        />
        <path
          d="M325.594 267.512L325.385 267.633V275.154L325.594 275.033V267.512Z"
          fill="#455A64"
        />
        <path
          d="M327.466 266.437L327.258 266.558V274.078L327.466 273.958V266.437Z"
          fill="#455A64"
        />
        <path
          d="M328.811 265.694L328.602 265.815L328.603 273.336L328.811 273.215V265.694Z"
          fill="#455A64"
        />
        <path
          d="M330.636 264.587L330.427 264.708V272.229L330.636 272.108V264.587Z"
          fill="#455A64"
        />
        <path
          d="M319.702 270.905L319.284 271.146V278.667L319.702 278.426V270.905Z"
          fill="#455A64"
        />
        <path
          d="M54.3079 193.004L49.0342 192.421C48.5258 192.366 48.1235 191.955 48.0776 191.445L47.4707 184.718C47.455 184.533 47.3008 184.393 47.1158 184.393C46.9308 184.393 46.7766 184.534 46.7609 184.718L46.154 191.446C46.1066 191.955 45.7058 192.366 45.1974 192.421L39.9252 193.004C39.7447 193.025 39.6086 193.177 39.6086 193.359C39.6086 193.541 39.7447 193.693 39.9252 193.714L45.1974 194.297C45.7058 194.352 46.1081 194.763 46.154 195.273L46.7609 202C46.7766 202.185 46.9308 202.325 47.1158 202.325C47.3008 202.325 47.455 202.185 47.4707 202L48.0776 195.272C48.1235 194.763 48.5258 194.352 49.0342 194.297L54.3079 193.714C54.4884 193.693 54.6253 193.541 54.6253 193.359C54.6245 193.176 54.4884 193.024 54.3079 193.004ZM48.9552 193.587C48.1114 193.68 47.4429 194.361 47.367 195.207L47.115 197.994L46.8639 195.209C46.7879 194.361 46.1194 193.68 45.2757 193.587L43.2107 193.359L45.2757 193.131C46.1194 193.038 46.7879 192.356 46.8639 191.51V191.509L47.115 188.723L47.367 191.509C47.4429 192.356 48.1114 193.038 48.9552 193.131L51.0202 193.359L48.9552 193.587ZM236.357 56.7264L228.191 55.824C227.321 55.7285 226.633 55.0253 226.554 54.1538L225.616 43.7348C225.598 43.5408 225.436 43.3919 225.241 43.3919C225.046 43.3919 224.884 43.5408 224.866 43.7348L223.928 54.1538C223.849 55.0253 223.16 55.7277 222.29 55.824L214.125 56.7264C213.934 56.7474 213.79 56.9091 213.79 57.1009C213.79 57.2926 213.934 57.4536 214.125 57.4746L222.29 58.3763C223.161 58.4733 223.849 59.1756 223.928 60.0464L224.866 70.4662C224.883 70.6602 225.046 70.8091 225.241 70.8091C225.436 70.8091 225.598 70.6602 225.616 70.4662L226.554 60.0464C226.633 59.1756 227.321 58.4733 228.191 58.3763L236.357 57.4746C236.548 57.4536 236.693 57.2919 236.693 57.1009C236.693 56.9084 236.548 56.7474 236.357 56.7264ZM228.109 57.628C226.884 57.7641 225.916 58.7523 225.805 59.9788L225.241 66.2399L224.677 59.9788C224.566 58.7523 223.597 57.7641 222.372 57.628L217.591 57.1001L222.372 56.5715C223.597 56.4361 224.566 55.448 224.677 54.2207L225.241 47.9596L225.805 54.2207C225.916 55.448 226.884 56.4361 228.109 56.5715L232.89 57.1001L228.109 57.628ZM22.924 178.232L26.4335 178.62C26.7719 178.657 27.0397 178.931 27.0705 179.27L27.4743 183.748C27.4848 183.872 27.5879 183.965 27.7104 183.965C27.8338 183.965 27.9368 183.872 27.9466 183.748L28.3504 179.269C28.3812 178.931 28.6482 178.657 28.9873 178.62L32.4984 178.232C32.6187 178.219 32.709 178.117 32.709 177.996C32.709 177.875 32.6187 177.774 32.4984 177.76L28.9873 177.372C28.6489 177.335 28.3812 177.061 28.3504 176.722L27.9466 172.244C27.936 172.121 27.833 172.028 27.7104 172.028C27.5879 172.028 27.4848 172.121 27.4743 172.244L27.0705 176.723C27.0389 177.061 26.7727 177.335 26.4335 177.372L22.924 177.76C22.8036 177.774 22.7126 177.875 22.7126 177.996C22.7126 178.117 22.8036 178.218 22.924 178.232ZM26.4862 177.844C27.0479 177.783 27.4931 177.329 27.5435 176.765L27.7104 174.91L27.8781 176.764C27.9285 177.329 28.3737 177.783 28.9354 177.844L30.3101 177.996L28.9354 178.148C28.3737 178.21 27.9285 178.664 27.8781 179.227L27.7104 181.082L27.5435 179.228C27.4931 178.664 27.0479 178.21 26.4862 178.148L25.1115 177.996L26.4862 177.844ZM32.9925 131.782L36.5021 132.17C36.8405 132.207 37.1082 132.481 37.139 132.82L37.5428 137.298C37.5534 137.421 37.6564 137.514 37.779 137.514C37.9023 137.514 38.0046 137.421 38.0151 137.298L38.4189 132.819C38.4498 132.481 38.7167 132.207 39.0559 132.17L42.567 131.782C42.6873 131.768 42.7775 131.667 42.7775 131.546C42.7775 131.425 42.6873 131.323 42.567 131.31L39.0559 130.922C38.7175 130.885 38.4498 130.611 38.4189 130.272L38.0151 125.794C38.0046 125.671 37.9015 125.577 37.779 125.577C37.6564 125.577 37.5534 125.67 37.5428 125.794L37.139 130.273C37.1074 130.611 36.8405 130.885 36.5021 130.922L32.9925 131.31C32.8722 131.323 32.7812 131.425 32.7812 131.546C32.7819 131.667 32.8729 131.768 32.9925 131.782ZM36.5555 131.394C37.1172 131.332 37.5624 130.879 37.6128 130.315V130.314L37.7805 128.46L37.9482 130.314C37.9986 130.879 38.4437 131.332 39.0055 131.394L40.3801 131.546L39.0055 131.698C38.4437 131.759 37.9986 132.214 37.9482 132.777L37.7805 134.632L37.6128 132.778C37.5624 132.214 37.1172 131.759 36.5555 131.698L35.1808 131.546L36.5555 131.394ZM47.5617 33.0624L51.4082 33.4881C51.779 33.5279 52.073 33.828 52.1061 34.2002L52.549 39.1078C52.5603 39.2424 52.6731 39.3446 52.8077 39.3446C52.9423 39.3446 53.0551 39.2424 53.0664 39.1078L53.5093 34.1995C53.5431 33.8287 53.8364 33.5287 54.2072 33.4881L58.0544 33.0624C58.186 33.0474 58.2853 32.9361 58.2853 32.8037C58.2853 32.6714 58.186 32.5601 58.0544 32.5451L54.2072 32.1194C53.8364 32.0796 53.5431 31.7795 53.5093 31.4073L53.0664 26.4997C53.0551 26.3651 52.9423 26.2628 52.8077 26.2628C52.6731 26.2628 52.5603 26.3651 52.549 26.4997L52.1061 31.408C52.0715 31.7788 51.779 32.0788 51.4082 32.1194L47.5617 32.5451C47.4301 32.5601 47.3301 32.6714 47.3301 32.8037C47.3301 32.9361 47.4301 33.0466 47.5617 33.0624ZM51.4654 32.6368C52.0805 32.5691 52.5685 32.072 52.6242 31.4547L52.8077 29.422L52.9912 31.4539C53.0468 32.072 53.5341 32.5691 54.1493 32.6376L55.6555 32.8037L54.1493 32.9699C53.5334 33.0376 53.0461 33.5347 52.9912 34.1528L52.8077 36.1855L52.6242 34.1536C52.5685 33.5354 52.0813 33.0384 51.4654 32.9699L49.9591 32.8037L51.4654 32.6368ZM196.053 38.4513L199.42 38.8235C199.744 38.8588 200 39.1213 200.03 39.4462L200.417 43.7423C200.428 43.8596 200.526 43.9499 200.644 43.9499C200.762 43.9499 200.861 43.8596 200.871 43.7423L201.259 39.4462C201.287 39.1213 201.545 38.8596 201.869 38.8235L205.235 38.4513C205.351 38.4385 205.438 38.3407 205.438 38.2249C205.438 38.1091 205.351 38.0113 205.235 37.9986L201.869 37.6263C201.545 37.591 201.288 37.3285 201.259 37.0037L200.871 32.7075C200.861 32.5902 200.762 32.4999 200.644 32.4999C200.526 32.4999 200.428 32.5902 200.417 32.7075L200.03 37.0037C200 37.3285 199.744 37.591 199.42 37.6263L196.053 37.9986C195.937 38.0113 195.85 38.1091 195.85 38.2249C195.85 38.3407 195.937 38.4385 196.053 38.4513ZM199.47 38.079C200.008 38.0196 200.434 37.5842 200.483 37.0443L200.643 35.265L200.804 37.0443C200.852 37.5842 201.279 38.0196 201.818 38.079L203.137 38.2249L201.818 38.3708C201.279 38.4302 200.852 38.8656 200.804 39.4056L200.643 41.1848L200.483 39.4056C200.434 38.8656 200.008 38.4302 199.47 38.3708L198.15 38.2249L199.47 38.079ZM259.475 42.2158L263.034 42.6098C263.377 42.6474 263.647 42.9249 263.678 43.2678L264.088 47.8092C264.099 47.9332 264.203 48.0287 264.328 48.0287C264.453 48.0287 264.557 47.9332 264.568 47.8092L264.977 43.2678C265.008 42.9249 265.279 42.6474 265.622 42.6098L269.181 42.2158C269.302 42.2022 269.395 42.0992 269.395 41.9759C269.395 41.8533 269.302 41.7503 269.181 41.7368L265.622 41.3435C265.279 41.3059 265.008 41.0284 264.977 40.6855L264.568 36.1441C264.557 36.02 264.453 35.9245 264.328 35.9245C264.203 35.9245 264.099 36.02 264.088 36.1441L263.678 40.6855C263.647 41.0291 263.377 41.3059 263.034 41.3435L259.475 41.7368C259.352 41.7503 259.26 41.8533 259.26 41.9759C259.26 42.0992 259.352 42.2022 259.475 42.2158ZM263.086 41.8225C263.656 41.7593 264.107 41.2998 264.159 40.7283L264.328 38.8476L264.497 40.7283C264.549 41.2991 265 41.7593 265.57 41.8225L266.964 41.9766L265.57 42.1308C265 42.194 264.549 42.6534 264.497 43.225L264.328 45.1057L264.159 43.225C264.107 42.6542 263.656 42.194 263.086 42.1308L261.692 41.9766L263.086 41.8225ZM323.605 119.457L320.552 119.12C320.258 119.088 320.025 118.85 319.999 118.555L319.647 114.661C319.638 114.554 319.549 114.473 319.442 114.473C319.335 114.473 319.246 114.554 319.237 114.661L318.886 118.556C318.859 118.85 318.626 119.088 318.332 119.12L315.28 119.457C315.175 119.469 315.096 119.557 315.096 119.663C315.096 119.768 315.175 119.856 315.28 119.868L318.332 120.206C318.626 120.237 318.86 120.476 318.886 120.771L319.237 124.665C319.246 124.772 319.335 124.853 319.442 124.853C319.549 124.853 319.638 124.772 319.647 124.665L319.999 120.77C320.025 120.476 320.258 120.238 320.552 120.206L323.605 119.869C323.71 119.857 323.789 119.769 323.789 119.664C323.789 119.558 323.71 119.469 323.605 119.457ZM320.507 119.795C320.018 119.848 319.632 120.243 319.588 120.733L319.442 122.344L319.297 120.734C319.253 120.243 318.865 119.848 318.376 119.794L317.182 119.662L318.376 119.53C318.865 119.476 319.253 119.081 319.297 118.591C319.297 118.59 319.297 118.59 319.297 118.59L319.442 116.98L319.588 118.59C319.632 119.081 320.019 119.476 320.507 119.53L321.702 119.662L320.507 119.795ZM351.479 155.238L348.426 154.9C348.132 154.868 347.899 154.63 347.872 154.335L347.521 150.441C347.512 150.335 347.422 150.253 347.316 150.253C347.209 150.253 347.119 150.335 347.11 150.441L346.76 154.336C346.733 154.63 346.5 154.868 346.206 154.9L343.153 155.238C343.049 155.25 342.97 155.338 342.97 155.443C342.97 155.548 343.049 155.636 343.153 155.648L346.206 155.986C346.5 156.017 346.734 156.256 346.76 156.551L347.11 160.444C347.119 160.551 347.209 160.632 347.316 160.632C347.422 160.632 347.512 160.551 347.521 160.444L347.872 156.55C347.899 156.256 348.132 156.017 348.426 155.986L351.479 155.648C351.583 155.636 351.662 155.548 351.662 155.443C351.662 155.338 351.583 155.25 351.479 155.238ZM348.381 155.575C347.892 155.629 347.505 156.023 347.462 156.513L347.316 158.124L347.171 156.514C347.126 156.023 346.739 155.629 346.25 155.575L345.055 155.442L346.25 155.31C346.739 155.256 347.126 154.862 347.171 154.371C347.171 154.371 347.171 154.371 347.171 154.371L347.316 152.761L347.462 154.371C347.505 154.861 347.893 155.256 348.381 155.31L349.575 155.442L348.381 155.575ZM311.433 82.7704L306.676 82.2455C306.217 82.1944 305.853 81.8244 305.813 81.3656L305.265 75.2955C305.25 75.1293 305.11 75.003 304.944 75.003C304.778 75.003 304.639 75.1293 304.623 75.2955L304.076 81.3656C304.035 81.8251 303.672 82.1951 303.213 82.2455L298.456 82.7704C298.293 82.7884 298.17 82.9268 298.17 83.09C298.17 83.2539 298.294 83.3923 298.456 83.4103L303.213 83.9367C303.672 83.9879 304.034 84.3579 304.076 84.8166L304.623 90.8867C304.638 91.0529 304.777 91.1792 304.944 91.1792C305.11 91.1792 305.25 91.0529 305.265 90.8867L305.813 84.8166C305.853 84.3571 306.217 83.9879 306.676 83.9367L311.433 83.4103C311.596 83.3923 311.719 83.2539 311.719 83.09C311.719 82.926 311.596 82.7884 311.433 82.7704ZM306.605 83.296C305.843 83.3803 305.241 83.9954 305.172 84.7579L304.946 87.2726L304.719 84.7579C304.65 83.9954 304.048 83.381 303.287 83.296L301.425 83.09L303.287 82.8847C304.048 82.8005 304.65 82.1853 304.719 81.4228L304.946 78.9081L305.172 81.4228C305.241 82.1861 305.844 82.8012 306.605 82.8847L308.467 83.09L306.605 83.296ZM293.388 102.527L289.54 102.101C289.17 102.061 288.876 101.761 288.842 101.389L288.4 96.4816C288.389 96.347 288.275 96.2447 288.141 96.2447C288.006 96.2447 287.893 96.347 287.882 96.4816L287.439 101.39C287.405 101.761 287.112 102.061 286.741 102.101L282.895 102.527C282.763 102.542 282.663 102.653 282.663 102.786C282.663 102.919 282.763 103.029 282.895 103.044L286.741 103.47C287.112 103.51 287.406 103.81 287.439 104.182L287.882 109.09C287.893 109.224 288.006 109.327 288.141 109.327C288.275 109.327 288.388 109.224 288.4 109.09L288.842 104.181C288.876 103.811 289.17 103.511 289.54 103.47L293.388 103.044C293.519 103.029 293.618 102.918 293.618 102.786C293.618 102.653 293.519 102.542 293.388 102.527ZM289.482 102.953C288.867 103.02 288.379 103.517 288.324 104.135L288.141 106.167L287.957 104.135C287.902 103.517 287.414 103.02 286.799 102.952L285.293 102.786L286.799 102.619C287.415 102.552 287.902 102.055 287.957 101.437L288.141 99.4046L288.324 101.437C288.38 102.055 288.867 102.552 289.482 102.62L290.989 102.786L289.482 102.953ZM326.613 173.039L322.003 172.529C321.559 172.481 321.208 172.122 321.167 171.676L320.637 165.796C320.623 165.634 320.487 165.511 320.326 165.511C320.166 165.511 320.03 165.634 320.017 165.796L319.486 171.677C319.445 172.122 319.095 172.481 318.65 172.529L314.041 173.039C313.883 173.057 313.764 173.19 313.764 173.35C313.764 173.509 313.883 173.641 314.041 173.66L318.65 174.17C319.095 174.218 319.447 174.578 319.486 175.023L320.017 180.903C320.03 181.065 320.166 181.187 320.326 181.187C320.487 181.187 320.623 181.064 320.637 180.903L321.167 175.022C321.208 174.578 321.559 174.218 322.003 174.17L326.613 173.66C326.771 173.642 326.89 173.509 326.89 173.35C326.89 173.19 326.771 173.058 326.613 173.039ZM321.933 173.549C321.196 173.63 320.611 174.226 320.545 174.966L320.325 177.401L320.105 174.966C320.039 174.226 319.455 173.63 318.717 173.549L316.912 173.35L318.717 173.15C319.455 173.069 320.039 172.473 320.105 171.733V171.732L320.325 169.297L320.545 171.732C320.611 172.473 321.196 173.068 321.933 173.15L323.738 173.35L321.933 173.549ZM346.874 42.9783L340.824 42.309C340.24 42.2459 339.779 41.7736 339.726 41.1893L339.029 33.4715C339.011 33.2595 338.834 33.0985 338.622 33.0985C338.41 33.0985 338.232 33.2595 338.214 33.4715L337.518 41.1908C337.464 41.7736 337.004 42.2459 336.421 42.309L330.371 42.9783C330.164 43.0024 330.008 43.1768 330.008 43.3859C330.008 43.5949 330.164 43.7694 330.371 43.7935L336.421 44.4628C337.004 44.5259 337.465 44.9982 337.518 45.5825L338.214 53.3003C338.232 53.5123 338.41 53.6732 338.622 53.6732C338.834 53.6732 339.011 53.5123 339.029 53.3003L339.726 45.581C339.778 44.9982 340.24 44.5259 340.824 44.4628L346.874 43.7935C347.082 43.7694 347.238 43.5949 347.238 43.3859C347.238 43.1761 347.082 43.0016 346.874 42.9783ZM340.733 43.6468C339.765 43.7536 338.998 44.5349 338.911 45.5065L338.622 48.704L338.333 45.508C338.246 44.5357 337.48 43.7536 336.511 43.6468L334.141 43.3851L336.511 43.1234C337.479 43.0167 338.246 42.2353 338.333 41.2637V41.2622L338.622 38.0662L338.911 41.2622C338.998 42.2353 339.764 43.0167 340.733 43.1234L343.102 43.3851L340.733 43.6468Z"
          fill="#F0F0F0"
        />
      </svg>
      <h3>Your cart is empty</h3>
      <Link to="/products">
        <Button primary>Continue Shopping</Button>
      </Link>
    </div>
  );
};

export default EmptyCart;
